<template>


  <div class="col-xl-6 col-lg-6 col-md-6 pl-2 px-0 screen-height" id="main_div" style="overflow: inherit !important; padding-left: 0px !important;">

    <div class="position-absolute zoomImg zoomImgFrame" v-if="isImgPreview">
      <img class="zoomImg" :src="zoomImg.zoomimgpath" style="" alt="img">
      <div class="footer_detail_block px-0">
        <ul class="footer_details">
          <li class="text-center">Nr. {{zoomImg.runid}}</li>
          <li>|</li>
          <li class="text-center">{{zoomImg.photodateDate}}</li>
          <li>|</li>
          <li class="text-center">{{zoomImg.photodateTimedate}} Uhr</li>
        </ul>
      </div>
    </div>



    <div ref="top-bar" class="map-top-area overflow-hidden" style="max-height: 45px;">

<!--      <div v-show="$store.state.photo.filtersactive" class="form-group mb-0 float-left" >-->
      <div v-show="isPlanSelected" class="form-group mb-0 float-left" >
        <div class="zoom-box zoom-box-relative float-left w-35 ">
          <div class="zoom-out">
            <button id="zoom-out" @click="canvasZoomOut" title="Rauszoomen">
              <i class="fa-solid fa-minus" @click="canvasZoomOut"></i>
<!--              <img class="img-responsive" src="@/assets/images/minus.png" style="width: 12px" alt="shap">-->
            </button>
          </div>
          <div class="zoom-input">
            <input type="range" id="zoom-input" v-model="zoomRange" min="0" max="1000" step="10" class="slider">
          </div>
          <div class="zoom-in" @click="canvasZoomIn">
            <button id="zoom-in" title="Reinzoomen">
              <i class="fa-solid fa-plus" @click="canvasZoomIn"></i>
<!--                            <img class="img-responsive" src="@/assets/images/plus_c.png" style="width: 12px" alt="shap">-->
            </button>
          </div>
        </div>

        <button type="button" @click="drawBoxOnCanvas"  class="btn-pp fa-lg" title="Auswahlrahmen aktivieren" :class="{'active': rectangle}" v-if="!isEdit">
          <i class="fa-solid fa-crop-simple"></i>
<!--        <button @click="drawBoxOnCanvas" class="text-center" title="Auswahlrahmen aktivieren" :class="{'active': rectangle}" v-if="!isEdit" style="border-radius: 6px; margin-top: -5px;">-->
<!--          <img src="@/assets/images/rahmen.svg" class="img-fluid" width="28" alt="box"/>-->
        </button>
      </div>

      <div class="form-group mb-0 float-left ml-1" v-if="isEdit">
        <button type="button" @click="moveflag = !moveflag" class="btn-pp fa-xl" title="Marker-Punkt verschieben" :class="{'active': moveflag} ">
          <i class="fa-solid fa-crosshairs""></i>
        </button>
      </div>

      <div class="form-group mb-0 float-left ml-1" v-if="devstate && isEdit && selectedPlan.is_georef">
        <button type="button" @click="setFlagsByImageGps" class="btn-pp fa-xl" title="Fotos mit GPS Koordinaten automatisch verorten">
          <i class="fa-solid fa-satellite""></i>
          <!--          <img src="@/assets/images/Shape (1).png" class="" width="19" alt="box"/>-->
        </button>
      </div>

      <div class="form-group float-right mb-0 mt-1 form-inline">
        <label for="plains" class=" mr-1"><strong>Planauswahl:</strong></label>
        <select @change="getPlainFlags" v-model="selectedPlan" id="plains"  style="max-width:300px; border-radius: 5px;">
          <option :value="plan" v-for="plan in plans">
            {{ plan.description}} - {{ plan.plannumber}} ({{ plan.runid}})
          </option>
        </select>
      </div>

    </div>

    <div class="map-bottom-area row pt-1 m-0 overflow-hidden" style="position: absolute; max-height: 38px; padding:10px; bottom: 0; width: 100%; left:0; border-top: 1px solid #d7d7d7; background-color: white; z-index: 100;">
      <div class="col-sm-2 pt-1">
        <div class="form-group float-left mt-1 form-inline" v-if="isEdit && canvas">
          <label for="currentdaterange" class=""></label>
          <select @change="setDateRange()" v-model="editrangeselect" id="currentdaterange" class="radius-20 w-100" style="max-width:200px">
            <option :value="erange.time" v-for="erange in editranges">
              {{ erange.title}}
            </option>
          </select>
        </div>
      </div>
      <!-- DateRangeSlider START -->
      <div class="col-sm-8 pt-1" :class="{'d-none': (!isEdit || !canvas)}">
        <div id="" class="d-flex date date-pick datepicker_edit mr-2" data-date-format="dd.mm.yyyy">
          <input id="datepicker_edit_from"
                 data-date-format="dd.mm.yyyy"
                 class="form-control date-input datepicker_edit_plan"
                 v-model="editdaterangeselect_from" type="text" readonly="">
        </div>
        <div class="filter level-filter level-req">
          <input type="text" class="edit-js-range-slider js-range-slider" id="ionRangeSliderEdit" name="my_range" value="" />
        </div>
        <div class="d-flex date date-pick datepicker_edit ml-2" data-date-format="dd.mm.yyyy">
          <input
            id="datepicker_edit_to"
            data-date-format="dd.mm.yyyy"
            class="form-control date-input datepicker_edit_plan "
            v-model="editdaterangeselect_to"  type="text" readonly="">
        </div>
      </div>
      <div class="col-sm-2" v-if="isEdit">
        <button type="button" @click="toggleFilterUse()"  class="btn btn-light ml-1 simple-photo-check" v-bind:class="{active : useFilter}">
          Filter nutzen
        </button>
      </div>


    </div>

<!--    <div class="p-1  position-absolute" id="single_temp_popup" v-bind:class="{'visible' : singleTempPhotoShow}">-->
<!--      <div class="image rounded border">-->
<!--        <i @click="singleTempPhotoShow = false;" class="fa fa-times-circle text-danger icon-cancel position-absolute"-->
<!--           aria-hidden="true" style="right: 4px;"></i>-->
<!--        <i @click="saveNewCreatedFlag" class="fa fa-check-circle text-success position-absolute" aria-hidden="true"-->
<!--           style="left: 4px; font-size: 1.3rem;"></i>-->
<!--        <img :src="$parent.drag_photo.src" width="130" class="img-thumbnail" alt="image">-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="pointertest" style="display:block;width:4px; height:4px; border-radius: 100%; background: purple; position:absolute; left:0; top:0; z-index:10000;"></div>-->

    <div class="p-1 pslider" id="popup_div"  v-bind:class="['columncount_'+pointerImages.length, {'visible' : imagesPopup, 'hoveractive': hoveractive, 'single_image' : pointerImages.length <2, 'multiple_images' : pointerImages.length >1}]"
    >
      <div class="close-preview position-absolute d-none">
        <i class="fa fa-times-circle-o text-danger" @click="closePhotoPopup"></i>
      </div>
      <div id="rightArrow">
        &#8250;
      </div>
      <div id="viewContainer" style="width: inherit; ">
        <div class="images-wrapper">
<!--          <div v-for="img in pointerImages" class="d-inline-block pl-0 pr-1" style="position: relative; width: 45px; height:45px; margin: 0px 2px;">-->
          <div v-for="img in pointerImages" class="d-inline-block" style="position: relative;">
            <div class="previewactionhandler" v-if="isEdit && zoomImg == img">
              <i v-if="isEdit && usercan('editor')"
                 @click="deleteFlag(img.pdflagid)" class="fa fa-trash" style="left:auto; right:2px;" data-toggle="tooltip" data-placement="top" title="Verortung entfernen">

              </i>
              <span  data-toggle="tooltip" data-placement="top" title="Blickrichtung ändern">
              <i v-if="isEdit && usercan('editor')"
                 @click="onImageClick(img)" class="fa fa-long-arrow-alt-right " style="left:auto; right:2px; rotate: -45deg;"></i>
              </span>
              <i v-if="isEdit && usercan('editor')"
                 @click="setlocationforimage(img.pdflagid)" class="fa-solid fa-crosshairs  " v-bind:class="{'active': relocateimage == img.pdflagid }" style="left:auto; right:2px;"  data-toggle="tooltip" data-placement="top" title="Verortung verschieben"></i>
            </div>
            <img
                 :src="img.imgUrlPath"
                 v-on:mouseenter="onImageHover(img)"
                 v-on:mouseleave="isImgPreview = false;onImageHoverLeave()"
                 :class="{'img-border': selectedFlagPhoto == img.pdphotoid}"
                 @click="onImageClick(img)"
                 width="60"
                 class="img-fluid zoom rounded p-0 planPreviewImages"
                 alt="img"
                 style="width:100%; height:100%; object-fit:cover"
            >
          </div>
        </div>

      </div>
      <div id="leftArrow">&#8249;</div>
    </div>

    <div class="w-100 text-center position-absolute zoom-loading" v-if="is_loading">
      <img class="img-fluid img-loading" src="@/assets/images/timeout.gif" alt="img1">
    </div>

    <div id="canvas_div" class="canvas_div overflow-hidden" style="max-height: calc(100% - 75px);height: calc(100% - 75px);min-height: auto; position: relative;">

      <div v-if="!isPlanSelected" class="photos_select_plan">
        <label><strong>Plan auswählen</strong></label>
        <div class="table-responsive cscroll" style="max-height: 500px;">
          <table class="table tble-custom plan_table">
            <thead>
            <tr>
              <th scope="col">Bezeichnung</th>
<!--              <th class="text-center" scope="col">Status</th>-->
              <th class="text-center" scope="col">GPS</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(plan , index) in plans" :key="index"
                @click="setSelectedPlan(plan)"
                :class="{ 'active-li' : active_el === plan.pdplanid }">
              <td>
                <div class="side-h">
                  <h6> {{ plan.description }} </h6><span>{{plan.plannumber}} </span>
                </div>
              </td>
              <td class="text-center">
                <i v-if="plan.is_georef === 0" class=""></i>
                <i v-else class="fa-solid fa-satellite"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <ul style="max-height: 250px; display: none; overflow: auto;" class="cscroll">
          <li v-for="plan in plans" class="pb-1">
            <div class="" @click="setSelectedPlan(plan)">
              <div class="d-flex">
                <div>{{ plan.description}}</div>
                <div class="pl-2">{{ plan.plannumber}} ({{ plan.runid}})</div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <canvas ref="canvas" id="canvass" style="width:100%;"></canvas>
<!--      <div class="canvas_pos_test" style="position: absolute; left:100px; top:100px;"> <i class="fa fa-crosshairs"></i></div>-->
    </div>
  </div>
</template>
<script>
import {fabric} from 'fabric'
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      useFilter: false,
      devstate: true,
      selectedPlan: {},
      canvas: null,
      zoomRange: 10,
      imagesPopup: false,
      pointerImages: [],
      imgSrc: {src: ''},
      h_dif: 0.0,
      zoomImg: '',
      w_dif: 0.0,
      zoomLevel: 10,
      isImgPreview: false,
      is_loading: false,
      panning: false,
      boxImages: [],
      singleTempPhoto: '',
      singleTempPhotoShow: false,
      dblClickedPoint: null,
      allow_drop: true,
      all_flags: [],
      flagsPhotoIds: [],
      selectedFlagPhoto: null,
      rectangle: null,
      moveflag: false,
      photocache: [],
      active_el: '',
      flags: [],
      color_red_arrow: 'rgba(255,0,0,0.6)',
      color_red_line: 'rgba(255,0,0,0.6)',
      color_red_pointer: 'rgba(255,0,0,0.6)',
      color_inactiv: 'rgba(0,0,0,0.6)',
      editranges: [
        {
          'title': 'Zeitraum (Alle)',
          'time': 'all'
        },
        {
          'title': 'letzte Wochen',
          'time': '1 week'
        },
        {
          'title': 'letzten 4 Wochen',
          'time': '4 weeks'
        },
        {
          'title': 'letzten 8 wochen',
          'time': '8 weeks'
        }
      ],
      editrangeselect: '1 week',
      editrangeSlider: null,
      hoverflag: {},
      planhasgps: true,
      editArrow: false,
      from: '',
      to: '',
      dateRangeFrom: moment(new Date()).add(-3, 'year').format('DD.MM.YYYY'),
      dateRangeTo: moment(new Date()).format('DD.MM.YYYY'),
      editdaterangeselect_from: moment(new Date()).add(-3, 'year').format('DD.MM.YYYY'),
      editdaterangeselect_to: moment(new Date()).format('DD.MM.YYYY'),
      relocateimage: false,
      hoveractive: false
    }
  },
  components: {
  },
  created () {
    console.log('PhotosCanvas Created')
    this.$store.dispatch('getPlans', this.$route.params.id)


    //
    // $(document).on('mouseover', '[data-toggle="tooltip"]', function() {
    //   $(this).tooltip({'show':true});
    // })

  },
  mounted () {
    let _this = this
    if (this.plans.length > 0) {
      _this.selectedPlan = _this.$store.state.photo.plans[0]
    }
    // const container = document.querySelector("#viewContainer");
    const container = document.querySelector('.images-wrapper')
    const lefty = document.querySelector('#leftArrow')
    lefty.addEventListener('click', function () {
      container.scrollLeft -= 20
    })
    const righty = document.querySelector('#rightArrow')
    righty.addEventListener('click', function () {
      container.scrollLeft += 20
    })
    if (this.$store.state.photo.gottoplan != null) {
      console.log('GoToPlan', this.$store.state.photo.gottoplan)
      this.$store.state.photo.gottoplan = null
    }
    // this.selectedPlan = {}
    console.log('Selected Canvas Plan', this.$store.state.photo.canvasplan)
    if (Object.keys(this.$store.state.photo.canvasplan).length >= 1) {
      this.$store.state.photo.gottoplan = this.$store.state.photo.canvasplan
      // this.$store.state.photo.canvasplan = this.$store.state.photo.canvasplan
      //
      // this.loadPlanOnMount(this.$store.state.photo.canvasplan)
    }


    if(this.dateMin != undefined && this.dateMax != undefined) {

      console.log('DR - RUN setDatePicker')

      this.setDatePickers();
    }
    $('body').tooltip({
      selector: '[data-toggle="tooltip"]'
    });


  },

  computed: {
    ...mapState({
      flagshighlight: state => state.photo.flagshighlight,
      activefilters: state => state.photo.activefilters
    }),
    creators () {
      return this.$store.state.creators
    },
    plans () {
      return this.$store.state.photo.plans
    },
    photos: {
      get () {
        return this.$store.state.photo.canvasPhotos
      },
      set (val) {
        this.$store.commit('setAllImagesForPhotoCanvas', val)
      }
    },
    isEdit () {
      return this.$store.state.photo.isEdit
    },
    isPlanSelected () {
      let keycount = Object.keys(this.selectedPlan).length
      console.log('KeyCount', keycount)
      if (keycount >= 1) return true
      return false
    },
    flagshighlightdd () {
      return this.$store.state.photo.flagshighlight
    },
    canvasplan () {
      return this.$store.state.photo.canvasplan
    },
    appUrl () {
      return process.env.VUE_APP_GET_METHOD_URL
    },
    curSession () {
      return localStorage.sessiontoken
    },

    range: {
      get () {
        return this.$store.state.photo.range
      },
      set (val) {
        this.$store.state.photo.range = val
        // this.$store.commit('setDateRangeTo', val)
      }
    },

    dateMin: {
      get () {
        if(this.$store.state.photo.meta.minimumdate == undefined || this.$store.state.photo.meta.minimumdate == '') {
          return undefined
        }
        return moment(this.$store.state.photo.meta.minimumdate).format('YYYY-MM-DD')
      },
      set (val) {
      }
    },
    dateMax: {
      get () {
        if(this.$store.state.photo.meta.maximumdate == undefined || this.$store.state.photo.meta.maximumdate == '') {
          return undefined
        }
        return moment(this.$store.state.photo.meta.maximumdate).format('YYYY-MM-DD')
      },
      set (val) {
      }
    },


  },

  watch: {
    '$store.state.photo.flagpreviewbygps': function (photo) {
      let canvas = this.canvas
      if (canvas) {
        console.log('SelectedPlan:', canvas)
        if (this.$store.state.photo.flagpreviewbygps != false) {
          this.addPointerPreviewByGps(photo)
          // this.$store.state.photo.flagpreviewbygps = false
        } else {
          this.removePointerPreviewByGps()
        }
      }
    },
    '$store.state.photo.flagbygps': function (photo) {
      let canvas = this.canvas
      if (canvas) {
        console.log('SelectedPlan:', canvas)

        if (this.$store.state.photo.flagbygps != false) {
          this.addPointerByGps(photo)
          this.$store.state.photo.flagbygps = false
        }
      }
    },
    '$store.state.photo.gottoplan': function (v) {
      if (this.$store.state.photo.gottoplan != null) {
        this.selectedPlan = this.$store.state.photo.gottoplan
        this.getPlainFlags()
        console.log('GoToPlan in PhotosCanvas', this.$store.state.photo.gottoplan)
        this.$store.state.photo.gottoplan = null
      }
    },
    'zoomRange': async function () {
      let obj = this
      console.log('WATCH zoomRange',obj.zoomRange)
      if (obj.zoomRange >= 0 && obj.zoomRange <= 1000) {
        let canvas = obj.canvas
        let c = (obj.zoomRange / 55) + 1
        canvas.zoomToPoint({x: canvas.getWidth() / 2, y: canvas.getHeight() / 2}, c)
        canvas.setZoom(c)
        await obj.canvas.getObjects().forEach(await function (point) {
          if (point.get('type') === 'group') {
            obj.setPointsZoom(obj.zoomRange, point)
          }
        })
        obj.imagesPopup = false
        obj.selectedFlagPhoto = null
        canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
        // Change The Zoom Level By Changing The Zoom
        obj.setZoomLevel()
      }
    },

    'zoomLevel': async function () {
      console.log('WATCH zoomLevel')
      let obj = this
      let c = obj.canvas
      obj.singleTempPhotoShow = false
      c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
    },

    'flagshighlight': function () {
      // console.log('FlagsToHighlight', this.$store.state.photo.flagshighlight)
      // console.log('Canvas Pointers', this.photos)
      this.addArrowForHightlightedImage(this.$store.state.photo.flagshighlight)
      this.editArrow = false
    },
    'photos': async function () {
      let obj = this
      let c = obj.canvas
      obj.singleTempPhotoShow = false
      if (c) {
        c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
      }
      await obj.removeAll()
      let params = {
        projectId: obj.$route.params.id,
        planId: obj.selectedPlan.pdplanid,
        zoom: obj.zoomLevel
      }
      // Gets the Flags On Plan and set Pointers On Changing Zoom
      await obj.getFlags(params)
    },
    'editrangeselect': async function () {

      let _this = this
      let enddate = this.formatDateByYear(this.$store.state.photo.endDate)
      let startdate = this.formatDateByYear(this.$store.state.photo.startDate)
      let mainenddate = this.formatDateByYear(this.$store.state.photo.endDate)

      // _this.editdaterangeselect_to
      // _this.editdaterangeselect_from

      if (_this.editrangeselect == '1 week') {
        startdate = moment().format('YYYY-MM-DD')
        enddate = moment().subtract(1, 'week').format('YYYY-MM-DD')
      } else if (_this.editrangeselect == '4 weeks') {
        startdate = moment().format('YYYY-MM-DD')
        enddate = moment().subtract(4, 'weeks').format('YYYY-MM-DD')
      } else if (_this.editrangeselect == '8 weeks') {
        startdate = moment().format('YYYY-MM-DD')
        enddate = moment().subtract(8, 'weeks').format('YYYY-MM-DD')
      } else if (_this.editrangeselect == 'all') {
      }

      _this.editdaterangeselect_from = moment(enddate).format('DD.MM.YYYY')
      _this.editdaterangeselect_to = moment(startdate).format('DD.MM.YYYY')

      // Calc start and end Number for slider
      let dif_from = moment(_this.editdaterangeselect_from, 'DD.MM.YYYY')
      let dif_main = moment(mainenddate, 'YYYY-MM-DD')
      let dif_num = moment.duration(dif_from.diff(dif_main)).asDays()

      console.log('DIF Nums', dif_from, dif_main, dif_num)

      let rangesliderinstance = $(".edit-js-range-slider").data('ionRangeSlider')
      console.log('isEditRange', rangesliderinstance)
      rangesliderinstance.update({
        from:dif_num,
        to: rangesliderinstance.options.max
      })

      console.log('WATCH _this.editdaterangeselect', _this.editdaterangeselect_from, _this.editdaterangeselect_to)

      let obj = this
      let c = obj.canvas
      obj.singleTempPhotoShow = false
      if (c) {
        c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
      }
      await obj.removeAll()
      let params = {
        projectId: obj.$route.params.id,
        planId: obj.selectedPlan.pdplanid,
        zoom: obj.zoomLevel
      }
      // Gets the Flags On Plan and set Pointers On Changing Zoom
      console.log('----------------------- GetFlags editRangeSelect -----------------------')
      await obj.getFlags(params)
    },

    '$store.state.photo.meta.minimumdate': function(v) {

      // console.log('this.$store.state.photo.meta.minimumdate Changed', this.$store.state.photo.meta.minimumdate)

      if(this.$store.state.photo.meta.minimumdate !== '') {
        let dif_from = moment(this.$store.state.photo.meta.minimumdate);
        let dif_to = moment(this.$store.state.photo.meta.maximumdate);
        let dif = moment.duration(dif_to.diff(dif_from)).asDays();
        this.range = [0 , dif];

        console.log('Start setDatePickers PhotoCanvas', this.$store.state.photo.meta.minimumdate, this.$store.state.photo.meta.maximumdate, 0, dif)


        this.setDatePickers()
        this.sliderInit = true
      }
    },


    'isEdit': async function () {
      this.editrangeselect = 'all'
      console.log('isEditChanged 1', this.isEdit)

      if(!this.isEdit || this.isEdit) {
        this.useFilter = false;
        let _this = this
        let params = {
          projectId: _this.$route.params.id,
          planId: _this.selectedPlan.pdplanid,
          zoom: _this.zoomLevel
        }

        console.log('isEditChanged Refetch Flags with params', params)
        this.getFlags(params)
      }


    },

    'selectedPlan': function () {
      // console.log('Select plan changed', this.selectedPlan)
      console.log('Canvas in SelectedPlan', this.canvas, this.selectedPlan)

      this.$store.state.photo.canvasplan = this.selectedPlan
    },
    'moveflag': function () {
      if (this.editArrow) {
        let c = this.canvas
        this.editArrow = !this.editArrow
        c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
      }
    }
  },

  methods: {

    toggleFilterUse() {

      let _this = this
      let params = {
        projectId: _this.$route.params.id,
        planId: _this.selectedPlan.pdplanid,
        zoom: _this.zoomLevel
      }
      params.zoomLevel = 10

      if(this.useFilter) {
        _this.useFilter = false
      } else {
        _this.useFilter = true
      }
      _this.getFlags(params)
      console.log('This.UseFilter', this.useFilter)


    },

    async setDatePickers () {
      // Define Base Values!
      let mindate = this.dateMin
      let maxdate = this.dateMax
      //
      this.datepicker_edit_from = moment(mindate, 'YYYY-MM-DD').format('DD.MM.YYYY')
      this.datepicker_edit_to = moment(maxdate, 'YYYY-MM-DD').format('DD.MM.YYYY')

      this.editdaterangeselect_from = moment(mindate, 'YYYY-MM-DD').format('DD.MM.YYYY')
      this.editdaterangeselect_to = moment(maxdate, 'YYYY-MM-DD').format('DD.MM.YYYY')

      await this.setDateRangeSlider();
      let my_range = $("#ionRangeSliderEdit").data("ionRangeSlider");
      let _this = this
      $('.datepicker_edit_plan').datepicker({
        autoclose: true,
        todayHighlight: true
      }).change(function (event){

        // datepicker_edit_from
        // datepicker_edit_to
        let from = mindate;
        let value = event.target.value;
        if (event.target.getAttribute('id') === 'datepicker_edit_from'){
          let dif_from = moment(value , 'DD.MM.YYYY');
          let dif = moment.duration(dif_from.diff(from)).asDays();
          console.log('setDateRange EDIT Dif From', dif, dif_from, from)
          my_range.update({
            from: Math.floor(dif),
          });
        } else {
          let to =  maxdate;
          let dif_to = moment(value , 'DD.MM.YYYY');
          let difToDate = moment.duration(dif_to.diff(to)).asDays();
          console.log('setDateRange EDIT Dif TO', difToDate, dif_to, to)
          my_range.update({
            to: Math.ceil(_this.range[1] + difToDate),
            // to: Math.floor(_this.range[1] + difToDate),
          });
        }

        let d_from = $('#datepicker_edit_from').val();
        let d_to = $('#datepicker_edit_to').val();
        _this.dateFrom = d_from;
        _this.dateTo  = d_to;
        _this.dateRangeFrom = d_from;
        _this.dateRangeTo  = d_to;
        _this.datepicker_edit_from = d_from;
        _this.datepicker_edit_to  = d_to;
        _this.editdaterangeselect_from = d_from
        _this.editdaterangeselect_to = d_to
        console.log('setDateRange d_FROM d_TO',
          _this.datepicker_edit_from,
          _this.datepicker_edit_to,
          value,
          mindate,
          maxdate)

        // _this.rangeOnChangeAction()

      });
    },

    setDateRangeSlider() {
      console.log('setDateRangeSlider Range', this.range)
      let _this = this
      $(".edit-js-range-slider").data('mindate', _this.range[0]);
      $(".edit-js-range-slider").data('maxdate', _this.range[1]);
      $(".edit-js-range-slider").ionRangeSlider({
        type: "double",
        min: _this.range[0],
        max: _this.range[1],
        drag_interval: true,
        hide_min_max: true,
        hide_from_to: true,
        onFinish: function (val){
          console.log('IonRangeSlider Edit Form Load Finish', val)
          _this.onSliderChange(val);

          $('#datepicker_edit_from').datepicker("setDate", $('#datepicker_edit_from').val())
          $('#datepicker_edit_to').datepicker("setDate", $('#datepicker_edit_to').val())

        },
        onChange: function (val){
          _this.onSliderChangeStep(val);
        }
      });
    },

    rangeOnChangeAction() {
      let obj = this
      let c = obj.canvas
      obj.singleTempPhotoShow = false
      // if (c) {
      //   c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
      // }
      // obj.removeAll()
      let params = {
        projectId: obj.$route.params.id,
        planId: obj.selectedPlan.pdplanid,
        zoom: obj.zoomLevel
      }
      // Gets the Flags On Plan and set Pointers On Changing Zoom
      console.log('----------------------- GetFlags editRangeSelect -----------------------')
      obj.getFlags(params)
    },


    onSliderChange(val){
      this.setDateRanges([val.from , val.to]);
    },

    onSliderChangeStep(val){
      let from = val.from;
      let to = val.to;

      console.log('DR - CHANGE ', val)

      let from_to_dates = this.calcDate([val.from, val.to])
      this.editdaterangeselect_from = from_to_dates[0]
      this.editdaterangeselect_to = from_to_dates[1]
      console.log('DR - onSliderChangeStep', this.editdaterangeselect_from, this.editdaterangeselect_to)

    },

    setDateRanges (range) {
      let _this = this
      let from = range[0];
      let to = range[1];

      let from_to_dates = this.calcDate(range)


      _this.editdaterangeselect_from = from_to_dates[0]
      _this.editdaterangeselect_to = from_to_dates[1]

      // _this.$store.state.photo.endDate = _this.$store.state.photo.RangeFrom
      // _this.$store.state.photo.startDate = _this.$store.state.photo.RangeTo

      console.log('DR - setDateRanges', range, {
        'From': _this.editdaterangeselect_from,
        'To' :_this.editdaterangeselect_to,
        'fromToDates': from_to_dates
      })

      _this.rangeOnChangeAction();
    },

    calcDate (range) {
      let _this = this
      let from = range[0] // Slider Left Point
      let to = range[1] // Slider Right Point

      let mindate = this.dateMin
      let maxdate = this.dateMax

      console.log('calcDate: minMax', mindate, maxdate, range)
      let oneday = 24 * 60 * 60 * 1000
      let firstDate = new Date(mindate)
      let secondDate = new Date(maxdate)
      let diffdays = Math.round(Math.abs((firstDate - secondDate) / oneday))

      let diffcounter = ''
      if(diffdays <= _this.range[1]) {
        //diffcounter = _this.range[1]
        diffcounter = diffdays / _this.range[1]
      } else {
        diffcounter = Math.round(diffdays / _this.range[1])
      }

      let from_date = moment(new Date(mindate)).add((from - 1) * diffcounter, 'days').format('DD.MM.YYYY')
      let to_date = moment(new Date(maxdate)).add( (to-_this.range[1]) * diffcounter, 'days').format('DD.MM.YYYY')

      return [from_date, to_date]
    },

    setSelectedPlan (plan) {
      this.selectedPlan = plan
      this.getPlainFlags()
    },

    getZoomArea (inst) {
    },
    setDateRange () {
      // console.log('New Daterange')
    },
    // Inetialize a canvas
    makeCanvas () {
      if (!(this.canvas === null || this.canvas === undefined)) {
        this.canvas.clear()
        this.canvas.dispose()
      }
      const canvas_ref = this.$refs.canvas
      let canvas = new fabric.Canvas(canvas_ref,
        {
          selection: false,
          controlsAboveOverlay: true,
          centeredScaling: false,
          allowTouchScrolling: false,
          hasBorders: false,
          lockRotation: true,
          lockMovement: false,
          lockMovementY: false,
          lockMovementX: false,
          lockUniScaling: false,
          lockScalingY: true,
          lockScalingX: true,
          preserveObjectStacking: true
        })
      this.canvas = canvas
      this.setCanvasBackgroundImage(canvas)
    },
    // Get Plan Image Files From API
    async getFileImage (plans) {
      let _this = this
      _this.zoomRange = 10
      _this.is_loading = true
      const jwt = localStorage.getItem('jwt');
      await fetch(
        process.env.VUE_APP_BASE_URL + plans.path + '&type=l&token=' + jwt,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }
      )
        .then(response => response.blob())
        .then(response => {
          let reader = new FileReader()
          reader.readAsDataURL(response)
          reader.onload = function () {
            _this.selectedPlan.src
            _this.imgSrc.src = reader.result
            _this.makeCanvas()
            _this.is_loading = false
            let params = {
              projectId: _this.$route.params.id,
              planId: _this.selectedPlan.pdplanid,
              zoom: _this.zoomLevel
            }
            params.zoom = 10
            // Gets the Flags On Plan and set Pointers
            console.log('----------------------- GetFlags getFileImage -----------------------')
            _this.getFlags(params)
          }
        })
    },

    // Set Background image to canvas
    async setCanvasBackgroundImage (canvas) {
      let obj = this
      let _this = this
      await fabric.Image.fromURL(obj.imgSrc.src, function (img) {
        let canvas_div = document.getElementById('canvas_div')
        let hgt = canvas_div.offsetHeight
        let canvas_width = canvas_div.offsetWidth

        let hPer = (hgt / img.height) * 100
        let width = (img.width / 100) * hPer

        if ( width > canvas_width ) {
          let wdh_difference = width - canvas_width
          let w_dif_per = (wdh_difference / width) * 100
          let cal_hgt = hgt / 100 * w_dif_per
          hgt = hgt - cal_hgt;
          width = canvas_width
        }

        let hPerForOffset = (hgt / img.height) * 100
        let widthForOffset = (img.width / 100) * hPerForOffset
        _this.offset_left = (canvas_width - widthForOffset) / 2

        let image_height = canvas_div.offsetHeight
        let widthForOffsetTop = (width / img.width) * 100
        let heightForOffsetTop = (img.height / 100) * widthForOffsetTop
        _this.offset_top = (image_height - heightForOffsetTop) / 2
        canvas.setHeight(hgt)
        canvas.setWidth(width)
        //
        // _this.image = img
        // _this.images.height = img.height
        // _this.images.width = img.width


        obj.offset_left = _this.offset_left
        obj.offset_top = _this.offset_top
        //
        // obj.offset_left = (canvas_div.offsetWidth - width) / 2
        // obj.offset_top = (canvas_div.offsetHeight - hgt) / 2
        //
        _this.h_dif = (hgt / img.height) * 100
        _this.w_dif = (width / img.width) * 100


        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          backgroundImageStretch: true
        })

        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height
        })



        obj.planimageheight = img.height
        obj.planimagewidth = img.width
        // For Find The Ratio To Draw The Pointers Accordingly
        // obj.h_dif = (hgt / img.height) * 100
        // obj.w_dif = (canvas_width / img.width) * 100

        // obj.img_width = img.width
        // obj.img_height = img.height


        canvas.renderAll()
        canvas.setWidth(canvas_width)
        let div_height = canvas_div.offsetHeight
        canvas.setHeight(div_height)
        canvas.centerObject(img)
        obj.$parent.zoomRange = 7


        obj.canvas = canvas

        obj.img_width = img.width
        obj.img_height = img.height
        // canvas.renderAll()

        let wth = canvas_div.offsetWidth

        obj.canvas_ow = canvas_div.offsetWidth
        obj.canvas_oh = canvas_div.offsetHeight

        // canvas.setWidth(wth) // Set width ???
        // canvas.centerObject(img)

        obj.addEventsOnCanvas(canvas)


      })
    },
    // Set Background image to canvas
    async setCanvasBackgroundImage_OLD_UNUSED (canvas) {
      // Get Canvas
      let obj = this
      await fabric.Image.fromURL(obj.imgSrc.src, function (img) {
        // Set Canvas Height According to image
        let canvas_div = document.getElementById('canvas_div')
        let Canvaslogtitle = 'CANVAS BUILD'

        console.log('Possible Canvas Size:', canvas_div, canvas_div.offsetWidth, canvas_div.offsetHeight, canvas_div.clientHeight)



        // Get Image Specs
        let image_width = img.width
        let image_height = img.height

        // calculate width and height of canvas

        let canvas_height = canvas_div.offsetHeight
        let canvas_width = canvas_div.offsetWidth

        let hgt = canvas_div.offsetHeight
        let wgt = canvas_div.offsetWidth
        let hPer = 0
        let width = 0
        let height = 0

        let ratio_img = img.width / img.height
        let ratio_canvas = canvas_div.offsetWidth / canvas_div.offsetHeight

        let canvas_img_ratio = ''
        // let canvas_img_ratio = img.width / canvas_width
        // canvas_height = img.height / canvas_img_ratio

        // console.log('Canvas DIV', canvas_div.offsetWidth, canvas_div.offsetHeight)

        let img_spec = 0

        if (ratio_img > 1 && ratio_canvas >= 1) { // Bild ist Breiter als Hoch und Canvas sind Breiter als Hoch!
          // console.log(Canvaslogtitle + ' Canvas- use canvas WIDTH', ratio_img, ratio_canvas)
          // calc canvas size based on values
          // Bild 5000x4000 Canvas 800x650
          console.log('Canvas Ratiotype: A', img.width, img.height, canvas_div.offsetWidth, canvas_div.offsetHeight)

          // canvas_img_ratio = canvas_height / img.height
          // canvas_width = img.width * canvas_img_ratio

          canvas_img_ratio = img.width / canvas_width
          canvas_height = img.height / canvas_img_ratio
          // img_spec = 1

          console.log('Canvas Final Ratio', canvas_width, canvas_height)
        } else if (ratio_img < 1 && ratio_canvas >= 1) { // Bild ist Höher als Breit und Canvas Breiter als Hoch!
          // console.log(Canvaslogtitle + ' Canvas- use canvas HEIGHT', ratio_img, ratio_canvas)
          // calc canvas size based on values
          console.log('Canvas Ratiotype: B', img.width, img.height, canvas_div.offsetWidth, canvas_div.offsetHeight)
          canvas_img_ratio = img.height / canvas_height
          canvas_width = img.width / canvas_img_ratio
          img_spec = 1
        } else if (ratio_img >= 1 && ratio_canvas < 1) { // Bild ist Breiter als Hoch und Canvas ist Höher als Breit
          // console.log(Canvaslogtitle + ' Canvas- use canvas HEIGHT B', ratio_img, ratio_canvas)
          // calc canvas size based on values
          console.log('Canvas Ratiotype: C', img.width, img.height, canvas_div.offsetWidth, canvas_div.offsetHeight)
          canvas_img_ratio = img.height / canvas_height
          canvas_width = img.width / canvas_img_ratio
          img_spec = 1
        } else { // Bild ist Höher als breit und Canvas ist Höher als Breit
          // console.log(Canvaslogtitle + ' Canvas- use canvas WIDTH B', ratio_img, ratio_canvas)
          // calc canvas size based on values
          console.log('Canvas Ratiotype: D', img.width, img.height, canvas_div.offsetWidth, canvas_div.offsetHeight)

          canvas_img_ratio = canvas_height / img.height
          canvas_width = img.width / canvas_img_ratio
        }

        // console.log('Canvas Params', canvas_img_ratio, canvas_height, canvas_width)

        // Bild = 5000 * 4800
        // Canvas = 880 * 760

        hPer = (canvas_height / img.height) * 100
        width = (img.width / 100) * hPer
        obj.offset_left = (canvas_div.offsetWidth - width) / 2
        // obj.offset_left = 0 // Img will always be full width!!!




        // Original
        // canvas.setWidth(canvas_width)
        // canvas.setHeight(canvas_height)


        canvas.setWidth(canvas_width)
        canvas.setHeight(canvas_height)

        // NEW
        //         canvas.setWidth(canvas_div.offsetWidth)
        //         canvas.setHeight(canvas_div.offsetHeight)
        console.log('FINAL Canvas Size:', canvas_width, canvas_height)

        // canvas.setWidth(wgt)
        // canvas.setHeight(hgt)

        // canvas.setOverlayColor('rgba(255, 73, 64, 0.6)', canvas.renderAll.bind(canvas));

        obj.planimageheight = img.height
        obj.planimagewidth = img.width
        // For Find The Ratio To Draw The Pointers Accordingly
        // obj.h_dif = (height / img.height) * 100
        // obj.w_dif = (width / img.width) * 100
        obj.h_dif = (canvas_height / img.height) * 100
        obj.w_dif = (canvas_width / img.width) * 100

        obj.img_width = img.width
        obj.img_height = img.height

        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height
        })

        if (img_spec) {
          console.log('Canvas Scale to WIDTH')
          img.scaleToWidth(canvas_width)
        } else {
          console.log('Canvas Scale to HEIGHT')
          img.scaleToHeight(canvas_height)
        }

        //
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          // opacity: 0.5,
          originX: 'center',
          originY: 'center',
          backgroundImageStretch: false,
          scaleX: canvas_width / img.width,
          scaleY: canvas_height / img.height
        })

        canvas.centerObject(img)
        obj.addEventsOnCanvas(canvas)
        obj.canvas = canvas
        canvas.renderAll()

        let wth = canvas_div.offsetWidth

        obj.canvas_ow = canvas_div.offsetWidth
        obj.canvas_oh = canvas_div.offsetHeight

        canvas.setWidth(wth) // Set width ???
        canvas.centerObject(img)
        obj.$parent.zoomRange = 5
      })
    },

    canvasZoomIn () {
      let obj = this
      this.getZoomArea(obj)


      let currentZoom = obj.zoomRange

      currentZoom = parseInt(currentZoom) + 10;

      if(currentZoom > 1000) {
        currentZoom = 1000;
      }
      if(currentZoom < 0) {
        currentZoom = 0;
      }
      obj.zoomRange = currentZoom

      // if (obj.zoomRange > 0 && obj.zoomRange < 1000) {
      //   obj.zoomRange += 10
      // }
    },

    canvasZoomOut () {
      let obj = this
      this.getZoomArea(obj)

      let currentZoom = obj.zoomRange

      currentZoom = parseInt(currentZoom) - 10;

      if(currentZoom > 1000) {
        currentZoom = 1000;
      }
      if(currentZoom < 0) {
        currentZoom = 0;
      }
      obj.zoomRange = currentZoom


      // if (obj.zoomRange > 0 && obj.zoomRange < 1010) {
      //   obj.zoomRange -= 10
      // }
    },

    // Set Events Listener On Canvas
    addEventsOnCanvas (canvas) {
      let obj = this
      let selObj
      canvas
        .on('mouse:wheel', function (opt) {
          console.log('mouse:wheel', opt)

          if(opt.e.deltaY > 0) {
            obj.canvasZoomOut()
          } else {
            obj.canvasZoomIn()
          }

        })
        // .on('object:over', function (e) {
        //   console.log('Object:over Canvas', e)
        // })
        // .on('dragover', function (e) {
        //   console.log('CANVAS:dragOver')
        // })
        // .on('dragenter', function (e) {
        //   console.log('CANVAS:dragenter')
        // })
        .on('mouse:over', function (e) {
          console.log('CANVAS:mouseOver',e)
          let _this = this
          if (obj.imagesPopup == true) {
            obj.imagesPopup = false
          }
          let hoverimages = []
          if (e.target !== undefined && e.target !== null) {
            if (e.target.items !== undefined) {
              if (Array.isArray(e.target.items) && e.target.items.length) {
                e.target.items.forEach(function (item, idx) {
                  let photoindex = obj.photos.findIndex((photo) => photo.pdphotoid == item.pdphotoid)
                  if (obj.photos[photoindex]) {
                    obj.photos[photoindex].hover = true
                    hoverimages.push(obj.photos[photoindex].pdphotoid)
                  }
                })
                obj.$store.dispatch('hoverPhotos', hoverimages)
              }
            }
          }
        })
        .on('mouse:out', function (e) {
          obj.$store.dispatch('hoverPhotos', [])
          // Hide the arrow here
        })
        .on('dragenter', function (e) {
          // let photo = obj.all_flags.findIndex(item => item.pdphotoid == obj.$parent.photo_id)
          let photo = obj.all_flags.find(item => item.pdphotoid == obj.$parent.photo_id)
          console.log('Canvas- Pointer- DragEnter', e.target)
          if (e.target) {
            let group = e.target.getObjects()
            console.log('Canvas- Pointer- DragEnter SRC', group)
            group.forEach(pt => {
              let radius = pt.radius
              let font = pt.fontSize
              pt.set({radius: radius + 7, fontSize: font + 5})
              console.log('HoverGroup', group)
            })
          }
          // Removed for Speed Issues
          // obj.canvas.renderAll()
          obj.allow_drop = !photo
        })
        .on('mouse:down', function (e) {
          obj.panning = true
          if (!e.target) {
            //
          }
        })
        .on('mouse:up', function (e) {
          obj.panning = false
          if (!e.target) {
            //
          }
        })
        .on('object:moving', function () {
          // console.log('Canvas- MouseMoving', obj)
          obj.panning = false
          //
        })
        .on('drop', async function (event) {
          // Ja nein Bestätigung
          // Shift gedrückt halten???
          // Wenn abbruch zurück
          // Wenn über einem anderen dann gleiche FlagPosition

          // await obj.moveFlagFunc(obj, canvas, event, _this)
          let _this = this
          console.log('DROP FLAG')
          if (obj.allow_drop) {
            let data
            // let photo_div = document.getElementById('single_temp_popup')
            let pointer = canvas.getPointer(event.e)
            let photo_id = obj.$parent.photo_id
            let plan_id = obj.selectedPlan.pdplanid
            let ow = _this.offset_left
            let x = (((pointer.x - obj.offset_left) / obj.w_dif) * 100) - (obj.img_width / 2)
            let y = (((pointer.y - obj.offset_top) / obj.h_dif) * 100) - (obj.img_height / 2)
            // photo_div.style.left = `${pointer.x - 65}px`
            // photo_div.style.top = `${pointer.y - 103}px`
            obj.singleTempPhotoShow = false // dont show photo Preview
            let viewx = 120
            let viewy = 120
            if (x > 0) viewx = -120
            if (y > 0) viewy = -120
            data = {
              'methodName': 'setFlag',
              'parameters': [{
                'created': '',
                'createdDateTime': 0,
                'degree': 180,
                'pdflagid': 0,
                'pdphotoid': photo_id,
                'pdplanid': plan_id,
                'pdpositionid': 0,
                'pdpositionname': '',
                'photoVO': null,
                'tiltangle': 0,
                'viewx': viewx,
                'viewy': viewy,
                'xcoord': x,
                'ycoord': y,
                '_explicitType': 'com\projectdocu\FlagVO'
              }],
              serviceName: 'ProjectdocuService'
            }
            if (obj.hoverflag && obj.hoverflag.viewx != undefined && !isNaN(obj.hoverflag.pdflagid) && !isNaN(obj.hoverflag.pdpositionid)) {
              data['parameters'][0].viewx = obj.hoverflag.viewx
              data['parameters'][0].viewy = obj.hoverflag.viewy
              data['parameters'][0].xcoord = obj.hoverflag.xcoord
              data['parameters'][0].ycoord = obj.hoverflag.ycoord
              // data['parameters'][0].pdflagid = obj.hoverflag.pdflagid
              data['parameters'][0].pdpositionid = obj.hoverflag.pdpositionid
            }
            console.log('Dropped Pointer Update', data, obj.$parent.drag_photo)

            if(obj.$parent.drag_photo) {

              let photodate = obj.$parent.drag_photo.photodate
              let checka = false
              let checkb = false

              console.log('Dropped Pointer Dates A', photodate, obj.editdaterangeselect_from, obj.editdaterangeselect_to, checka, checkb, _this)


              if(moment(photodate, 'YYYY-MM-DD hh:mm:ss') > moment(obj.editdaterangeselect_to, 'DD.MM.YYYY')) {
                obj.editdaterangeselect_to = moment(photodate, 'YYYY-MM-DD hh:mm:ss').format('DD.MM.YYYY')
                checka = true
              }

              if(moment(photodate, 'YYYY-MM-DD hh:mm:ss') < moment(obj.editdaterangeselect_to, 'DD.MM.YYYY')) {
                obj.editdaterangeselect_from = moment(photodate, 'YYYY-MM-DD hh:mm:ss').format('DD.MM.YYYY')
                checkb = true
              }

              console.log('Dropped Pointer Dates B', photodate, obj.editdaterangeselect_from, obj.editdaterangeselect_to, checka, checkb)


              // editdaterangeselect_from: moment(new Date()).add(-3, 'year').format('DD.MM.YYYY'),
              //   editdaterangeselect_to: moment(new Date()).format('DD.MM.YYYY'),
            }




            await obj.createOrUpdateFlags(data)
          } else {
            obj.$toast.error('Photo Already Exist On This Plan')
          }
        })
        .on('mouse:move', function (e) {
          if (obj.panning && e && e.e) {
            // console.log('Canvas- MouseMove', obj.panning, e, e.e)
            let delta = new fabric.Point(e.e.movementX, e.e.movementY)
            canvas.relativePan(delta)
            let canvasViewPort = canvas.viewportTransform

            let bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
            if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
              canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
            }
            let rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
            if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
              canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
            }
          }
        })
    },


    saveNewCreatedFlag () {
      let c = this.canvas
      c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))

      this.singleTempPhotoShow = false
      this.refreshFlags()
      this.canvas.renderAll()
      this.singleTempPhotoShow = false
      return true
    },

    loadPlanOnMount (plan) {
      this.selectedPlan = plan
      this.getPlainFlags()
    },
    // Get Flags to Draw Pointer on Canvas
    async getPlainFlags () {
      console.log('getPlainFlags', this.selectedPlan)

      await this.getFileImage(this.selectedPlan)
      this.imagesPopup = false
      this.selectedFlagPhoto = null


      // await this.setDateRangeSlider();

    },

    // Send Request To Api to Fetch The Result
    async getFlags (params) {
      let _this = this
      let canvas = this.canvas
      // console.log('PARAMS', params)
      // process.env.VUE_APP_BASE_URL + '/project/' + params.projectId + '/plan/' + params.planId + '/getflags',
      let planid = params.planId

      let enddate = this.formatDateByYear(this.$store.state.photo.endDate)
      let startdate = this.formatDateByYear(this.$store.state.photo.startDate)


      let operands = {'operands': [
          {
            '_explicitType': 'com\\projectdocu\\PredicateOperandBetweenVO',
            'fieldvalueFrom': enddate,
            'fieldname': 'photodate-day',
            'fieldvalueTo': startdate
          }, {
            'fieldvalue': params.planId,
            'fieldname': 'pdplanid',
            '_explicitType': 'com\\projectdocu\\PredicateOperandEQVO'
          }
        ],
        '_explicitType': 'com\\projectdocu\\PredicateOperatorAndVO'
      }


      let order = [
        {
          '_explicitType': 'com\\projectdocu\\OrderSettingVO',
          'fieldname': 'photodate',
          'order': 'DESC'
        }
      ]


      console.log('getFlags is edit', params, this.isEdit, operands)
      if(this.isEdit === true) {

        // TODO: Fix enddate and startdate, they are switched!!!s

        startdate = moment(_this.editdaterangeselect_from, 'DD.MM.YYYY').format('YYYY-MM-DD')
        enddate = moment(_this.editdaterangeselect_to, 'DD.MM.YYYY').format('YYYY-MM-DD')




        if(this.useFilter) {
          operands = JSON.parse(JSON.stringify(this.$store.state.photo.currentPhotoFilter))
          // Alle Filter und Planfilter
          operands.operands.push({'operands': [
              {
                '_explicitType': 'com\\projectdocu\\PredicateOperandBetweenVO',
                'fieldvalueFrom': startdate,
                'fieldname': 'photodate-day',
                'fieldvalueTo': enddate
              }, {
                'fieldvalue': params.planId,
                'fieldname': 'pdplanid',
                '_explicitType': 'com\\projectdocu\\PredicateOperandEQVO'
              }
            ],
            '_explicitType': 'com\\projectdocu\\PredicateOperatorAndVO'
          })
        } else {
          operands.operands = [{'operands': [
              {
                '_explicitType': 'com\\projectdocu\\PredicateOperandBetweenVO',
                'fieldvalueFrom': startdate,
                'fieldname': 'photodate-day',
                'fieldvalueTo': enddate
              }, {
                'fieldvalue': params.planId,
                'fieldname': 'pdplanid',
                '_explicitType': 'com\\projectdocu\\PredicateOperandEQVO'
              }
            ],
            '_explicitType': 'com\\projectdocu\\PredicateOperatorAndVO'
          }]
        }


        order = JSON.parse(JSON.stringify(this.$store.state.photo.currentPhotoOrder))
      }


      console.log('PhotoCanvas', {
        'start': startdate,
        'end': enddate,
        'filter': this.useFilter,
        'params': params,
        'operands': operands,
        'editmode': this.isEdit
      });

      let postparams = [
        params.projectId,
        1000,
        0,
        operands,
        order
      ];

      console.log('_this.editdaterangeselect_from/to', startdate, enddate, postparams, _this.editdaterangeselect_from, _this.editdaterangeselect_to)

      const jwt = localStorage.getItem('jwt')
      await axios.post(
        process.env.VUE_APP_BASE_AMF_URL + 'getflags&token=' + jwt,
        {
          'parameters': postparams,
          'serviceName': 'ProjectdocuService',
          'methodName': 'getFlagsOfProject'
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }
      ).then(response => {
        let flags = response.data.flags
        _this.all_flags = response.data.flags // flags.map(f => f.items).flat() // Added 2-12-2020
        let flagstemp = []
        flags.forEach(function (flag, idx) {
          let spotexists = flagstemp.findIndex((e) => e.xcoord == flag.xcoord && e.ycoord == flag.ycoord)
          let index_a = flagstemp.findIndex((e) => e.xcoord == flag.xcoord)
          let index_b = flagstemp.findIndex((e) => e.ycoord == flag.ycoord)
          flag.photoVO.xcoord = flag.xcoord
          flag.photoVO.ycoord = flag.ycoord
          flag.photoVO.viewx = flag.viewx
          flag.photoVO.viewy = flag.viewy
          flag.photoVO.pdflagid = flag.pdflagid
          flag.photoVO.hover = false

          if (!flag.items) {
            flag.items = []
          }

          let res = []

          if (_this.isEdit) {
            // if (_this.rectangle) {
            //   res = _this.photocache.filter((photo) => photo.pdphotoid === flag.photoVO.pdphotoid)
            // } else {
              res = _this.photos.filter((photo) => photo.pdphotoid === flag.photoVO.pdphotoid)
            // }
            // console.log('Result of found Flag', res)
            flag.activeflag = true

            if (res.length) {
              flag.photoVO.src = res[0].src
            }

            //if (index_a >= 0 && index_a == index_b) {
            if (spotexists >= 0) {
              flagstemp[index_a].items.push(flag.photoVO)
            } else {
              flag.items = [flag.photoVO]
              flagstemp.push(flag)
            }
          } else {
            // if (_this.rectangle) {
            //   res = _this.photocache.filter((photo) => photo.pdphotoid === flag.photoVO.pdphotoid)
            // } else {
              res = _this.photos.filter((photo) => photo.pdphotoid === flag.photoVO.pdphotoid)
            // }
            if (Array.isArray(res) && res.length == 1) {
              // console.log('Result of found Flag', res)
              flag.activeflag = true
              flag.photoVO.src = res[0].src

              if (index_a >= 0 && index_a == index_b) {
                flagstemp[index_a].items.push(flag.photoVO)
              } else {
                flag.items = [flag.photoVO]
                flagstemp.push(flag)
              }
            } else {
              flag.activeflag = false
            }
          }
        })

        // console.log('Flags Redordered:', flags, flagstemp)
        _this.flags = flagstemp

        // Draw Pointers On Canvas

        // console.log('All Flags', flags)

        // console.log('Canvas- FLAGS to Draw', flags)
        _this.drawPointer(flagstemp)
        if(_this.canvas != null) {
          _this.canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
          _this.canvas.renderAll()
        }


        // get Flag element dates array
        // let startelement = flags[0]
        // let endelement = flags[flags.length-1]

        // console.log('Start end END', {
        //   'start': startelement,
        //   'end': endelement
        // })
      }).catch(e => {
        console.log(e)
      })
    },

    async deleteFlag (flagId) {
      console.log('Delete', flagId)
      let _this = this
      let projectid = this.$route.params.id

      let url = `${process.env.VUE_APP_BASE_URL}/project/${projectid}/photos/deleteflag`
      const jwt = localStorage.getItem('jwt');
      url = process.env.VUE_APP_BASE_AMF_URL + 'deleteflags&token=' + jwt
      await axios.post(url,
        {
          'parameters': [
            flagId
          ],
          'serviceName': 'ProjectdocuService',
          'methodName': 'deleteFlag'
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }
      ).then(res => {
        if (res.status === 200 || res.statusText === 'OK') {
          _this.refreshFlags()
          _this.imagesPopup = false
          _this.singleTempPhotoShow = false
          _this.$toast.success('Markierung gelöscht')
        }
      }).catch(error => {
        _this.$toast.success('Oops something went wrong... !')
        console.log(error)
      })
    },

    formatDate (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    formatDateByYear (value) {
      let temp = ''
      // console.log('Before split', value)
      if (value != 'undefined' && (typeof value === 'string')) {
        {
          let sp = value.split('.')
          return (sp[2] + '-' + sp[1] + '-' + sp[0])
        }
        if (temp == 'Invalid date') {
          return ''
        } else {
          return temp
        }
      }
    },

    calculatePositionOnCanvas (xcoord, ycoord) {
      let _this = this
      let oh = _this.offset_top
      let ow = _this.offset_left
      let iw = _this.img_width
      let ih = _this.img_height
      let wdif = _this.w_dif
      let hdif = _this.h_dif

      console.log('calculatePositionOnCanvas Params', {
        oh : oh,
        ow : ow,
        iw : iw,
        ih : ih,
        wdif : wdif,
        hdif : hdif,
      })


      let x = (((xcoord + (iw / 2)) / 100) * wdif) + ow
      // let x = (((xcoord + (iw / 2)) / 100) * wdif)
      let y = (((ycoord + (ih / 2)) / 100) * hdif) + oh

      return {x: x, y: y}
    },

    // Draw Pointers On Canvas
    drawPointer (flags) {
      let _this = this
      // Remove all before new render
      _this.removeAll()

      let points = []
      let canvas = this.canvas
      console.log('CANVAS', canvas)



      flags.forEach(function (item, idx) {
        let pos = _this.calculatePositionOnCanvas(item.xcoord, item.ycoord)
        let x = pos.x
        let y = pos.y


        // console.log('Calculatet Position:', pos,  x, y)

        if (item.activeflag) {
          let obj = _this.createCircleWithText(item)

          obj.set({
            id: item.pdflagid,
            data: item,
            items: item.items,
            left: x,
            top: y,
            originX: 'center',
            originY: 'center',
            selectable: true,
            hasControls: false,
            hasBorders: true,
            objectCaching: false
          })

          // console.log('DRAW POINTERS SettedObjectForPointer', obj)
          _this.setPointsZoom(_this.zoomRange, obj)
          _this.addEventsOnPointers(obj)
          if (_this.canvas != null) {
            _this.canvas.add(obj)
          }

          // console.log('AddObjectToCanvas', item.pdflagid, obj)
        }
      })

      if (flags.length) {
        if (_this.canvas != null) {
          _this.canvas.renderAll()
        }
      }
      // console.log('------------- POINTS', _this.canvas.getObjects().filter((item) => item.get('type') === 'group'))

      return points
    },

    // Draw Arrow On Canvas Reference to photo coords
    addArrowToCanvas (obj, img, isCircle = false, newelement = false) {
      let _this = this
      let c = _this.canvas
      let circle = ''
      c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))

      if (newelement) {
        circle = isCircle ? obj : obj.getObjects('circle')[0]
        // _this.editArrow = true
      } else {
        circle = !isCircle ? obj : obj.getObjects('circle')[0]
      }
      img = isCircle ? img : obj.data

      console.log('AddArrowToCanvas - A', obj, img, circle)

      let pos = _this.calculatePositionOnCanvas(img.xcoord, img.ycoord)
      let x = pos.x
      let y = pos.y
      let s_x = img.xcoord + img.viewx
      let s_y = img.ycoord + img.viewy
      let flagpos = _this.calculatePositionOnCanvas(s_x, s_y)
      let viewXA = flagpos.x
      let viewYA = flagpos.y
      const triangle = new fabric.Triangle({
        // fill: 'red',
        fill: _this.color_red_arrow,
        height: circle.radius * 2.5,
        width: circle.radius * 2,
        top: viewYA,
        left: viewXA,
        hasBorders: false,
        hasControls: false,
        originX: 'center',
        originY: 'center',
        lockScalingX: true,
        lockScalingY: true,
        lockRotation: true
      })

      // On Triangle Moving function
      triangle.on('moving', syncObjects)

      // On Triangle ( Arrow ) on Moved function
      triangle.on('moved', function (event) {
        let pointer = _this.canvas.getPointer(event.e)

        let imgpos = _this.calculatePositionOnCanvas(img.xcoord, img.ycoord)
        let srcpos = _this.calculatePositionOnCanvas(pointer.x, pointer.y)
        let x = ((pointer.x - imgpos.x) / _this.w_dif) * 100
        let y = ((pointer.y - imgpos.y) / _this.h_dif) * 100
        img.viewx = x
        img.viewy = y
        _this.updateArrowPosition(img, x, y)

        c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))

        _this.editArrow = false
      })

      const coords = [
        triangle.left,
        triangle.top,
        obj.left + (circle.radius / 10),
        obj.top + (circle.radius / 10)
      ]

      const line = new fabric.Line(coords, {
        // stroke: 'red',
        stroke: _this.color_red_line,
        strokeWidth: circle.radius,
        selectable: false,
        originX: 'center',
        originY: 'center'
      })
      function syncObjects (e) {
        const x1 = triangle.left
        const y1 = triangle.top
        const x2 = obj.left + (circle.radius / 10)
        const y2 = obj.top + (circle.radius / 10)

        line.set('x1', x1)
        line.set('y1', y1)
        line.set('x2', x2)
        line.set('y2', y2)

        const angle = _this.calcArrowAngle(x1, y1, x2, y2)

        triangle.set('angle', angle)
        triangle.setCoords()
        c.renderAll()
      }

      syncObjects()

      c.preserveObjectStacking = true
      c.add(line, triangle)
      c.renderAll()
    },

    // update the position of arrow on move the arrow
    async updateArrowPosition (img, arrowX, arrowY) {
      // console.log('updateArrowPosition', img, arrowX, arrowY)

      let _this = this
      let plan_id = this.selectedPlan.pdplanid
      let data = {
        'methodName': 'setFlag',
        'parameters': [{
          'created': '',
          'createdDateTime': 0,
          'degree': 180,
          'pdflagid': img.pdflagid,
          'pdphotoid': img.pdphotoid,
          'pdplanid': plan_id,
          'pdpositionid': 0,
          'pdpositionname': '',
          'photoVO': null,
          'tiltangle': 0,
          'viewx': arrowX,
          'viewy': arrowY,
          'xcoord': img.xcoord,
          'ycoord': img.ycoord,
          '_explicitType': 'com\\projectdocu\\FlagVO'
        }],
        serviceName: 'ProjectdocuService'
      }

      let url = `${process.env.VUE_APP_BASE_URL}/project/${this.$route.params.id}/photos/setflag`
      const jwt = localStorage.getItem('jwt');
      url = process.env.VUE_APP_BASE_AMF_URL + 'setflags&token=' + jwt

      await axios.post(url, data,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }
      ).then(res => {
        _this.$toast.success('Blickrichtung aktualisiert')
      }).catch(errors => {
        console.log(errors)
      })
    },

    // create new flags by drop image on canvas
    async createOrUpdateFlags (data, moved = false) {
      let _this = this
      let url = `${process.env.VUE_APP_BASE_URL}/project/${this.$route.params.id}/photos/setflag`
      const jwt = localStorage.getItem('jwt');
      url = process.env.VUE_APP_BASE_AMF_URL + 'setflags&token=' + jwt

      return await axios.post(url, data,
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }
      ).then(res => {
        if (res.statusText === 'OK') {
          if (moved) {
            _this.$toast.success('Markierung aktualisiert')
          } else {
            // New Flag
            let circle = _this.createTempCircle()
            let x = ((data.xcoord / 100) * _this.w_dif)
            let y = ((data.ycoord / 100) * _this.h_dif)
            circle.set({
              left: x,
              top: y,
              selectable: false
            })
            // console.log('createOrUpdateFlags', res)
            _this.canvas.add(circle)
            _this.canvas.renderAll()

            let current_photo_idx = _this.photos.findIndex((photo) => photo.pdphotoid == data.parameters[0].pdphotoid)
            console.log('Current Photo', _this.photos, data, _this.photos[current_photo_idx], current_photo_idx)
            if (current_photo_idx >= 0) {
              _this.photos[current_photo_idx].inplan = 1
            }

            _this.$toast.success('Neue Markierung gesetzt')

            // _this.addArrowToCanvas(circle, res.data[0], true, true)
            _this.saveNewCreatedFlag()
            //   .then(function() {
            //   console.log('AddArrowToCanvasFinishLoading')
            // })


            // _this.canvas.on('object:added', function(object) {
            _this.editArrow = true
            // TEST
            let subres = false
            let singlepoint
            let singleimg
            setTimeout(function() {
              // not the best solution... :-( Alternatives??
              let points = _this.canvas.getObjects().filter((item) => item.get('type') === 'group')
              console.log('AddArrowToCanvas POINTS', {'Points': points, 'Canvas': _this.canvas.getObjects(), 'dataItem': data.parameters[0].pdphotoid});
              points.forEach(function (point, idx) {
                if (Array.isArray(point.items) && point.items.length >= 1) {
                  console.log('Res', point.items.filter((item) => item.pdphotoid == data.parameters[0].pdphotoid))
                  if (point.items.filter((item) => item.pdphotoid == data.parameters[0].pdphotoid).length >= 1) {
                    subres = point.items.filter((item) => item.pdphotoid == data.parameters[0].pdphotoid)
                    singlepoint = point
                    singleimg = subres[0]
                  }
                }
              })

              if (subres) {
                console.log('AddArrowToCanvas PointerItem', {'Circle': circle, 'SubRes': subres, 'Singlepoint': singlepoint, 'SingleImage': singleimg})
                _this.addArrowToCanvas(singlepoint, singleimg, true)
              }
            }, 500);
            // console.log('AddArrowToCanvas Circle', {'Circle': circle, 'ResImg': res.data, 'PointerImages': _this.pointerImages});

          }

          // _this.ajaxbus.$emit('ajaxready')
        }
      })
    },

    // for the calculation of arrow angle
    calcArrowAngle (x1, y1, x2, y2) {
      let angle = 0, x, y

      x = (x2 - x1)
      y = (y2 - y1)

      if (x === 0) {
        angle = (y === 0) ? 0 : (y > 0) ? Math.PI / 2 : Math.PI * 3 / 2
      } else if (y === 0) {
        angle = (x > 0) ? 0 : Math.PI
      } else {
        angle = (x < 0) ? Math.atan(y / x) + Math.PI : (y < 0) ? Math.atan(y / x) + (2 * Math.PI) : Math.atan(y / x)
      }
      angle = angle * 180 / Math.PI
      return angle - 90
    },

    // Add Text In Circle Method
    createCircleWithText (item) {
      // console.log('Canvas- Items:', item)

      let zoomlevel = this.zoomLevel

      let radius = 15 - (zoomlevel * 1.5)
      if (radius >= 12) radius = 12

      let bgcolor = this.color_inactiv

      // console.log('Active Flag:', item.activeflag)

      if (item.activeflag) {
        bgcolor = this.color_red_pointer
      }

      if (item.flagcolor != undefined) {
        bgcolor = item.flagcolor
      }

      let data = {
        // fill: 'red',
        fill: bgcolor,
        radius: radius, // 15
        hoverCursor: 'default',
        originX: 'center',
        originY: 'center',
        borderColor: 'red',
        hasBorders: true,
        borderScaleFactor: 0,
        padding: 0,
        objectCaching: false
      }
      if (item.preview) {
        data.preview = true
      }

      let spotcount = '1'
      if(item.items) {
        spotcount = (item.items.length) + ''
      }
      if(spotcount == '1') {
        spotcount = '';
      }


      console.log('---Items', item, spotcount, radius)
      let txt = new fabric.IText(spotcount, {
        fontFamily: 'Calibri',
        fontSize: 8,
        borderScaleFactor: 0,
        padding: 0,
        objectCaching: false,
        noScaleCache: false,
        lockUniScaling: true,
        textAlign: 'center',
        originX: 'center',
        originY: 'center',
        fill: '#FFF',
        left: '1', //LayoutCoordX(STA),
        top: '1', //LayoutCoordY(BL-BLOffset)-radius-.4
      })

      let circle = new fabric.Circle(data)

      let groupdata = {
        lockMovementX: true,
        lockMovementY: true,
        lockScalingX: true,
        lockScalingY: true,
        hasControls: false,
        selection: false,
        hasBorders: true,
        originX: 'middle',
        originY: 'middle',
        subTargetCheck: true,
        selectionBackgroundColor: 'rgba(0,0,0,0.5)',
        objectCaching: false
      }

      if (item.preview) {
        groupdata.preview = true
      }

      // return new fabric.Group([circle, text], {
      return new fabric.Group([circle, txt], groupdata)
    },

    // create a temp  circle
    createTempCircle () {
      let zoomlevel = this.zoomLevel

      let radius = 15 - (zoomlevel * 1.5)
      if (radius >= 12) radius = 12

      return new fabric.Circle({
        // fill: 'red',
        fill: this.color_red_pointer,
        radius: radius, // 13,
        hoverCursor: 'default',
        originX: 'center',
        originY: 'center'
      })
    },

    // Get Images On Flags / Pointers
    async getImagesFiles (pointers) {
      let _this = this
      let photo = {}
      this.pointerImages = []

      // console.log('ITEMS', pointers)

      const jwt = localStorage.getItem('jwt');
      await pointers.items.forEach(item => {
        item.imgUrlPath = process.env.VUE_APP_GET_METHOD_URL + 'img&size=s&projectid=' + item.projectid + '&id=' + item.pdphotoid + `&token=` + jwt

        _this.pointerImages.push(item)
      })
    },

    // Add Events on Pointers
    addEventsOnPointers (pointer) {
      let _this = this
      let canvas = _this.canvas
      // Mouse Double Click Event / Method
      let isDrag = false

      // pointer.on('mousedblclick', function (e) {
      pointer.on('mouseover', function (e) {
        // if(isDrag) return



        if (isDrag) return

        let off_x = event.pageX - $('#canvass').offset().left
        let off_y = event.pageY - $('#canvass').offset().top


        // console.log('Pointer- Mouseover', {
        //   'A.event': event,
        //   'A.event.y': event.y,
        //   'A.event.x': event.x,
        //   'etarget:': e.target,
        //   'off_x': off_x,
        //   'off_y': off_y,
        //   'pointer': pointer,
        //   'pointercenter': pointer.getCenterPoint(),
        //   'getLocalPointer' : pointer.getLocalPointer(e),
        //   'CanvasPointer': canvas.getPointer(e.e, true),
        //   'byOrigin': pointer.getPointByOrigin('left', 'top'),
        //   'canvasOffset': _this.canvas._offset,
        //   'canvas': canvas,
        //   'lastPointerPos': canvas.wrapperEl._previousPointer,
        //   'offsets': {
        //     'offset_left': _this.offset_left,
        //     'offset_top': _this.offset_top,
        //   }
        // })

        $('.canvas_pos_test').css({'top': pointer.top, 'left': pointer.left})


        _this.imagesPopup = true
        _this.selectedFlagPhoto = e.target.data.pdflagid
        _this.singleTempPhotoShow = false
        _this.dblClickedPoint = e.target
        let pointers = e.target.data
        let circlecenter = pointer.getCenterPoint()
        let localcenter = pointer.getLocalPointer(e.e)

        // let point_x = canvas.getPointer(e.e, true).x
        // let point_y = canvas.getPointer(e.e, true).y

        let point_x = Math.round(event.x / 10) * 10
        let point_y = Math.round(event.y / 10) * 10

        point_x = Math.round((event.x - 10) / 10 ) * 10 + 10 - pointer.radius
        point_y = Math.round((event.y - 20) / 20 ) * 20 + 10 - pointer.radius

        let outerheight = $('.map-top-area').outerHeight();

        // console.log('Pointer-Coords', {
        //   'y': event.y,
        //   'x': event.x,
        //   'c.offset-top': _this.canvas._offset.top,
        //   'c.offset-left': _this.canvas._offset.left,
        //   'pointer.radius': pointer.radius,
        //   'pointer.byOrigin': pointer.getPointByOrigin('left', 'top'),
        //   'n.left': _this.canvas._offset.left + pointer.getPointByOrigin('left', 'top').x,
        //   'n.top': _this.canvas._offset.top + pointer.getPointByOrigin('left', 'top').y,
        //   'pointerCanvas': pointer.canvas.viewportTransform,
        //   'oCoords': pointer.oCoords.tl,
        //   'left.calc': _this.canvas._offset.left - pointer.oCoords.tl.x,
        //   'top.calc': _this.canvas._offset.top - pointer.oCoords.tl.y,
        //   'topNavOuterHeight': outerheight,
        //   'pointeroffwidth': pointer.getScaledWidth(),
        //   'width': pointer.width * pointer.canvas.viewportTransform[0],
        // });

        let r = (pointer.width * pointer.canvas.viewportTransform[0]) / 2;


        // $('.pointertest').css({
        //   'top': ( pointer.oCoords.tl.y + outerheight + (r / 2)),
        //   'left': (pointer.oCoords.tl.x + (r / 2)) + 12
        // })

        // * _this.zoomLevel

        _this.getImagesFiles(pointers)
        let popup = document.getElementById('popup_div')
        // popup.style.top = (parseInt(Math.round(point_y - _this.canvas._offset.top))) + 'px'
        // popup.style.left = (parseInt(Math.round(point_x - _this.canvas._offset.left))) + 'px'
        popup.style.top = (pointer.oCoords.tl.y + outerheight + (r)) + 'px'
        popup.style.left = ((pointer.oCoords.tl.x + (r)) + 12) + 'px'
      })

      pointer.on('mousedown', function (e) {
        if (!_this.isEdit || !_this.moveflag) {
          return
        }
        isDrag = true
        pointer.lockMovementX = false
        pointer.lockMovementY = false
        // console.log('OnActions Pointers- MouseDown', e)
      })

      pointer.on('mouseup', function (e) {
        if (!_this.isEdit || !_this.moveflag) {
          return
        }

        // console.log('OnActions Pointers- MouseUp', e)
        let canvas_div = document.getElementById('canvas_div')

        console.log('Flag Moved - e.target.data', e.target)
        console.log('Flag Moved - getPointer', _this.canvas.getPointer(event))

        // Get the moved Flag from _this.all_flags

        let hgt = canvas_div.offsetHeight
        let wgt = canvas_div.offsetWidth
        let viewx = e.target.data.viewx
        let viewy = e.target.data.viewy
        let plan_id = e.target.data.pdplanid
        let pdpositionid = e.target.data.pdpositionid
        let created = e.target.data.created
        let coords = {'x': _this.canvas.getPointer(event).x, 'y': _this.canvas.getPointer(event).y}
        let x_old = ((coords.x / _this.w_dif) * 100) - (_this.img_width / 2)
        let y_old = ((coords.y / _this.h_dif) * 100) - (_this.img_height / 2)
        let data = {}

        let pointer_v2 = canvas.getPointer(e.e)
        let x = (((pointer_v2.x - _this.offset_left) / _this.w_dif) * 100) - (_this.img_width / 2)
        let y = (((pointer_v2.y - _this.offset_top) / _this.h_dif) * 100) - (_this.img_height / 2)

        // console.log('MouseUp after Drag', {
        //   'e': e,
        //   'coords': coords,
        //   'x': x,
        //   'y': y,
        //   'hgt': hgt,
        //   'wgt': wgt,
        //   '_this.w_dif': _this.w_dif,
        //   '_this.h_dif': _this.h_dif,
        //   'v2': {
        //     'pointer': pointer_v2,
        //     'x': x,
        //     'y': y
        //   }
        // })

        let offset_left = (canvas_div.offsetWidth - wgt) / 2
        let offset_top = (canvas_div.offsetHeight - hgt) / 2
        let plancoords = _this.calculatePositionOnCanvas(e.pointer.x, e.pointer.y)
        let photo_id
        let pdflagid = e.target.data.pdflagid
        let canvas_offset_left = _this.canvas._offset.left
        let canvas_offset_top = _this.canvas._offset.top
        let canvas_width = _this.canvas.width // 732
        let canvas_height = _this.canvas.height // 609


        let rerenderfull = false

        if(_this.relocateimage != false) {
          rerenderfull = true
        }

        e.target.data.items.forEach(function (item, idx) {

          let runaction = true
          if (_this.relocateimage != false && _this.relocateimage != item.pdflagid) {
            runaction = false
          }

          if (runaction) {
            console.log('MouseUp after Drag image and item', _this.relocateimage, item)
            data = {
              'methodName': 'setFlag',
              'parameters': [{
                'created': created,
                'createdDateTime': 0,
                'degree': 180,
                'pdflagid': item.pdflagid,
                'pdphotoid': item.pdphotoid,
                'pdplanid': plan_id,
                'pdpositionid': pdpositionid,
                'pdpositionname': '',
                'photoVO': item,
                'tiltangle': 0,
                'viewx': item.viewx, // use old viewx and viewy positions. So that the arrow mows the same way!
                'viewy': item.viewy,
                'xcoord': x,
                'ycoord': y,
                '_explicitType': 'com\\projectdocu\\FlagVO'
              }],
              serviceName: 'ProjectdocuService'
            }

            item.viewx = e.target.data.viewx
            item.viewy = e.target.data.viewy
            item.xcoord = x
            item.ycoord = y

            isDrag = false
            pointer.lockMovementX = true
            pointer.lockMovementY = true
            _this.createOrUpdateFlags(data, true)
            _this.canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
            _this.canvas.renderAll()

          }

        })

        // ajaxbus.$on('ajaxready', function(id) {
        //
        //   alert('Ajax finsihed', id)
        // })

        if(rerenderfull) {
          setTimeout(function() {
            console.log('Refresh Flags')
            _this.refreshFlags()
            _this.canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
            _this.canvas.renderAll()
            _this.setlocationforimage(false)

          }, 500)
        }
      })

      pointer.on('mouse:out', function (e) {
        console.log('OnActions Pointers- MouseOut', e)
        _this.selectedFlagPhoto = null
      })

      pointer.on('dragenter', function (e) {
        console.log('A: Canvas- Pointer- DragEnter Target', e.target)
        if (e.target && e.target.data) {
          _this.hoverflag = e.target.data
        }
        let group = e.target.getObjects()
        group.forEach(pt => {
          console.log('A: Canvas- Pointer- DragEnter Group', group)
          let radius = pt.radius
          let font = pt.fontSize
          pt.set({radius: radius + 7, fontSize: font + 5})
        })
        _this.canvas.renderAll()
      })

      pointer.on('dragleave', function (e) {
        console.log('Pointer- DragLeave')
        _this.hoverflag = {}
        let group = e.target.getObjects()
        group.forEach(pt => {
          let radius = pt.radius
          let font = pt.fontSize
          pt.set({radius: radius - 7, fontSize: font - 5})
        })
        _this.canvas.renderAll()
      })

      pointer.on('drop', function (e) {
        // console.log('Pointer- Drop', e)

        // return
        let group = e.target.getObjects()
        group.forEach(pt => {
          let radius = pt.radius
          pt.set({radius: radius - 7})
        })
        _this.canvas.renderAll()
      })
    },

    // refresh flags on create or change the in flags position
    refreshFlags: function () {
      // console.log('Pointer- REFRESHFLAGS')
      let obj = this
      obj.removeAll()
      let params = {
        projectId: obj.$route.params.id,
        planId: obj.selectedPlan.pdplanid,
        zoom: obj.zoomLevel
      }
      // Gets the Flags On Plan and set Pointers On Changing Zoom
      console.log('----------------------- GetFlags refreshFlags -----------------------')
      obj.getFlags(params)
    },

    // Handle The Zoom
    setPointsZoom (range, obj) {
      let objs = obj.getObjects()
      let zoomdata
      let radiuscalc = 500

      let basefontsize = 8
      let baseradius = 5
      if (range >= 0 && range <= 50) {

      } else if (range >= 100) {
        baseradius = radiuscalc / range
        basefontsize = (radiuscalc / range)*1.2
      }

      for (let i in objs) {

        objs[i].set({
          // radius: 10.5,
          radius: baseradius,
          fontSize: basefontsize
          // fontSize: 13
        })
        zoomdata = {
          // radius: 10.5,
          // height: 10.5*2,
          // width: 10.5*2
          radius: baseradius,
          height: baseradius * 2,
          width: baseradius * 2
          // fontSize: 13
        }

        // objs[i].set(zoomdata)
      }
      obj.set(zoomdata)

      // console.log(zoomdata)

      if (this.canvas != null) {
        // Removed for Speed issues
        // this.canvas.renderAll()
      }
    },

    // Set a Zoom Level
    setZoomLevel () {
      let obj = this
      let zoom = this.zoomRange
      if (zoom >= 1 && zoom <= 50) {
        obj.zoomLevel = 10
      }
      if (zoom >= 51 && zoom <= 100) {
        obj.zoomLevel = 9
      } else if (zoom >= 101 && zoom <= 150) {
        obj.zoomLevel = 8
      } else if (zoom >= 151 && zoom <= 160) {
        obj.zoomLevel = 7
      } else if (zoom >= 201 && zoom <= 220) {
        obj.zoomLevel = 6
      } else if (zoom >= 251 && zoom <= 270) {
        obj.zoomLevel = 5
      } else if (zoom >= 301 && zoom <= 320) {
        obj.zoomLevel = 4
      } else if (zoom >= 351 && zoom <= 370) {
        obj.zoomLevel = 3
      } else if (zoom >= 401 && zoom <= 430) {
        obj.zoomLevel = 2
      } else if (zoom >= 500 && zoom <= 550) {
        obj.zoomLevel = 1
      }
    },

    // On Image Hover
    onImageHover (img) {
      console.log('ZoomImage', img)
      img.photodateDate = moment(String(img.photodate)).format('DD.MM.YYYY')
      img.photodateTimedate = moment(String(img.photodate)).format('HH:mm')
      const jwt = localStorage.getItem('jwt');
      img.zoomimgpath = process.env.VUE_APP_GET_METHOD_URL + 'img&size=l&projectid=' + img.projectid + '&id=' + img.pdphotoid + `&token=` + jwt
      this.zoomImg = img
      // this.zoomImg = img.imgSrc
      // console.log('onImageHover', this.dblClickedPoint, img)
      this.addArrowToCanvas(this.dblClickedPoint, img, true)
      this.isImgPreview = true
      this.hoveractive = true


      // if(this.isEdit) {
      //   console.log('Init ToolTip')
      //   $('[data-toggle="tooltip"]').tooltip()
      // }

    },

    onImageClick (img) {
      img.photodateDate = moment(String(img.photodate)).format('DD.MM.YYYY')
      img.photodateTime = moment(String(img.photodate)).format('hh:mm:ss')
      const jwt = localStorage.getItem('jwt');
      img.zoomimgpath = process.env.VUE_APP_GET_METHOD_URL + 'img&size=l&&projectid=' + img.projectid + '&id=' + img.pdphotoid + `&token=` + jwt

      this.zoomImg = img
      if (!this.isEdit) return

      // console.log('onImageHover', this.dblClickedPoint, img)
      if (this.editArrow) {
        this.editArrow = false
      } else {
        if (this.moveflag) {
          this.moveflag = !this.moveflag
        }
        this.editArrow = true
      }
      this.addArrowToCanvas(this.dblClickedPoint, img, true)
      this.isImgPreview = true
    },

    setlocationforimage (img) {
      this.relocateimage = img

      if(img != false) {
        this.moveflag = true
      } else {
        this.moveflag = false
      }
    },

    onImageHoverLeave () {
      if (this.editArrow) {

      } else {
        let canvas = this.canvas
        canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
        canvas.renderAll()
      }

      this.hoveractive = false

      // if (!this.selectedFlagPhoto || !this.isEdit) {
      //   let canvas = this.canvas
      //   canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
      //   canvas.renderAll()
      // }
    },
    // Remove Pointer on Canvas ( used for remove the points )
    async removeAll () {
      let canvas = this.canvas
      if (canvas) {
        await canvas.remove(...canvas.getObjects().filter((item) => item.get('type') !== 'rect'))
        await canvas.renderAll()
      }
    },

    addArrowForHightlightedImage (img) {
      let canvas = this.canvas

      let _this = this
      let res = false
      let singlepoint
      let singleimg
      // this.dblClickedPoint, img, true

      // console.log('CANVAS', canvas, img)
      if (!canvas) return

      if (img === false) {
        canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
        return
      }

      let points = canvas.getObjects().filter((item) => item.get('type') === 'group')

      points.forEach(function (point, idx) {
        if (Array.isArray(point.items) && point.items.length >= 1) {
          // console.log('Res', point.items.filter((item) => item.pdphotoid == img.pdphotoid))

          if (point.items.filter((item) => item.pdphotoid == img.pdphotoid).length >= 1) {
            res = point.items.filter((item) => item.pdphotoid == img.pdphotoid)
            // console.log('Result', res)
            singlepoint = point
            singleimg = res[0]
            // console.log('_this.flags single', point, img.pdphotoid, res[0])
          }
        }
      })

      if (res) {
        // console.log('FoundFlag', singleimg, singlepoint)
        _this.addArrowToCanvas(singlepoint, singleimg, true)
      }
    },

    getVisibleArea(canvas) {
      const zoom = canvas.getZoom(); // Aktuelle Zoomstufe
      const viewportTransform = canvas.viewportTransform; // Enthält die Offsets (Verschiebungen)

      const offsetX = viewportTransform[4] || 0; // Horizontale Verschiebung
      const offsetY = viewportTransform[5] || 0; // Vertikale Verschiebung

      const visibleWidth = canvas.width / zoom;  // Sichtbare Breite
      const visibleHeight = canvas.height / zoom; // Sichtbare Höhe

      const visibleX = -offsetX / zoom; // Horizontale sichtbare Startkoordinate
      const visibleY = -offsetY / zoom; // Vertikale sichtbare Startkoordinate

      return {
        x: visibleX,
        y: visibleY,
        width: visibleWidth,
        height: visibleHeight,
      };
    },


// Draw a box in canvas
    drawBoxOnCanvas () {
      if (this.rectangle) {
        this.removeBoxFromCanvas()
        return
      }

      if (this.photocache.length <= 0) {
        this.photocache = this.photos
      }


      const visibleArea = this.getVisibleArea(this.canvas);




      let x = this.canvas.getWidth()
      let y = this.canvas.getHeight()

      let rectangle = new fabric.Rect({
        width: 200,
        height: 100,
        fill: '',
        stroke: 'red',
        strokeWidth: 0.5,
//        left: x / 2,
//        top: y / 2,
        left: visibleArea.x + (visibleArea.width - 200) / 2, // X-Koordinate
        top: visibleArea.y + (visibleArea.height - 100) / 2, // Y-Koordinate
        // transparentCorners: true,
        transparentCorners: false,
        cornerColor: 'red',
        cornerStrokeColor: 'transparent',
        // borderColor: 'pink',
        active: true,
        padding: 0,
        originX: 'left',
        originY: 'top',
        hasRotatingPoint: false,
        objectCaching: false,
        noScaleCache: false,
        strokeUniform: true
      })

      // Render the Rect in canvas
      this.rectangle = rectangle
      this.$store.state.photo.rectangleActive = true

      let rectbox = rectangle;
      let obj = this;
      let canvas = obj.canvas


      this.canvas.add(rectangle)
      this.addEventsOnRectBox(rectangle)


      this.getBoxPosition(rectbox)

      this.canvas.setActiveObject(rectangle)
      this.canvas.renderAll()
    },

    removeBoxFromCanvas () {
      this.canvas.remove(this.rectangle)
      this.rectangle = null
      this.boxImages = []
      this.photos = this.photocache
      this.photocache = []

      this.$store.state.photo.rectangleActive = false

      this.$store.commit('setRectangleProps', {});

    },

    getBoxPosition(e) {
      let obj = this;
      let rectbox = this.rectangle
      // let rectbox = e.target;
      let canvas = obj.canvas

      let zoomFactor = canvas.getZoom();
      const viewport = this.canvas.viewportTransform;

      // Transformierte Koordinaten berechnen
      let coords = rectbox.getCoords();
      coords = coords.map(point => ({
        x: (point.x - viewport[4]) / zoomFactor, // X-Offset entfernen und auf Zoom normalisieren
        y: (point.y - viewport[5]) / zoomFactor  // Y-Offset entfernen und auf Zoom normalisieren
      }));

      let x_1 = (((coords[0].x - obj.offset_left) / obj.w_dif) * 100) - (obj.img_width / 2)
      let y_1 = (((coords[0].y - obj.offset_top) / obj.h_dif) * 100) - (obj.img_height / 2)

      let x_2 = (((coords[2].x - obj.offset_left) / obj.w_dif) * 100) - (obj.img_width / 2)
      let y_2 = (((coords[2].y - obj.offset_top) / obj.h_dif) * 100) - (obj.img_height / 2)


      console.log('Rec Box getCoords', coords, {
        'A_x_1': x_1,
        'A_y_1': y_1,
        'B_x_1': x_2,
        'B_y_1': y_2,
        'zoom': zoomFactor,
        'viewport': viewport
      })

      obj.$store.commit('setRectangleProps', {'x_tl': x_1, 'y_tl': y_1, 'x_br': x_2, 'y_br': y_2});
    },

    // Add Events On Box
    addEventsOnRectBox (rect) {
      let obj = this
      // Event on Rectangle Move
      rect.on('moved', function (e) {
        let box = e.target

        obj.getBoxPosition(e)

        // obj.getPhotosInsideBox(box)
      })
      // Event on MouseOver
      rect.on('mouseover', function (e) {
        let canvas = obj.canvas

        e.target.canvas.lockMovement = true
        e.target.canvas.lockMovementX = true
        e.target.canvas.lockMovementY = true
      })
      // Event while scaling
      rect.on('scaling', function (e) {
        let canvas = obj.canvas

        obj.panning = false

        canvas['lockMovement'] = true
        canvas['lockMovementX'] = true
        canvas['lockMovementY'] = true
        // console.log('------- SCALING', canvas, e)
      })
      // Event Run Rectangle Resized
      rect.on('scaled', function (e) {
        let rectbox = e.target;
        let canvas = obj.canvas

        obj.getBoxPosition(e);

        console.log('------- SCALED', e, e.target)
        // obj.disableCanvasMovement(false)
        // obj.canvas.selection = true
        let box = e.target
        // obj.getPhotosInsideBox(box)
      })
    },

    // Get Images Inside Rectangle
    getPhotosInsideBox (box) {
      return;
      let obj = this
      let left = box.left
      let top = box.top
      let width = box.width * box.scaleX
      let height = box.height * box.scaleY
      let endLeft = left + width
      let endTop = top + height
      obj.boxImages = []
      obj.photos = []
      // console.log('Pointer- obj.canvas.getObjects()', obj.canvas.getObjects())
      // console.log('Pointer- Position', left, top, width, height, endLeft, endTop)

      console.log('getImagesInsideBox', {
        left: left,
        top: top,
        width: width,
        height: height,
        endLeft: endLeft,
        endTop: endTop
      })


      obj.canvas.getObjects().forEach(function (point) {
        if (point.get('type') === 'group') {
          if ((point.left >= left && point.left <= endLeft) && (point.top >= top && point.top <= endTop)) {
            // console.log('Pointer- obj.canvas.getObjects()', point, point.data.photoVO, obj.photos.filter((photo) => photo.pdphotoid === point.data.pdphotoid))

            obj.getImagesFilesInsideBox(point)

            point.items.forEach(function (photoitem, ix) {

            })
            // console.log('Pointer - ADD POINT', point.items)
            if (!obj.photos.filter((photo) => photo.pdphotoid === photoitem.pdphotoid) == []) {
            }
          }
        }
      })
    },

    // get Images inside the red box
    async getImagesFilesInsideBox (pointers) {
      console.log('Call: getImagesFilesInsideBox', pointers)
      let _this = this
      const jwt = localStorage.getItem('jwt');
      await pointers.items.forEach(photo => {
        let photourl = process.env.VUE_APP_GET_METHOD_URL + 'img&projectid=' + photo.projectid + '&id=' + photo.pdphotoid + `&token=` + jwt
        // process.env.VUE_APP_BASE_URL + "getfile/photo/" + item.photo_id + "/450x450/8:8",
        fetch(
          photourl,
          {
            headers: {
              apitoken: localStorage.apikey,
              deviceid: localStorage.deviceid
            }
          })
          .then(response => response.blob())
          .then(response => {
            let reader = new FileReader()
            reader.readAsDataURL(response)
            reader.onload = function () {
              photo.src = reader.result

              let resfind = _this.photos.filter((sphoto) => sphoto.pdphotoid == photo.pdphotoid)
              // console.log('Resfind', resfind)

              if (resfind.length <= 0) {
                _this.photos.push(photo)
              }
            }
          })
      })
    },

    // Close Images-popup on canvas pointers
    closePhotoPopup () {
      console.log('ClosePopUp')
      this.imagesPopup = false
      this.selectedFlagPhoto = null
      this.singleTempPhotoShow = false
      let canvas = this.canvas
      canvas.remove(...canvas.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))
    },

    removePointerPreviewByGps () {
      let canvas = this.canvas
      canvas.remove(...canvas.getObjects().filter((item) => item.preview !== undefined))
    },

    addPointerByGps (photo, multiadd = false) {
      let _this = this

      let flags = this.flags
      console.log('Flags', flags)
      let photos = this.getMapLocation(this.selectedPlan.refpoints, [photo])
      console.log('AddPointerByGPS (Photocanvas) Real', photo, this.selectedPlan, photos)
      for (let i in photos) {
        let photo = photos[i]

        let viewx = 20
        let viewy = 20
        if (photo.x > 0) viewx = -20
        if (photo.y > 0) viewy = -20

        if (photo.exifhasgps) {
          let northdif = this.getNorthDifference(_this.selectedPlan.refpoints)
          let radius = 200 // Distance from point
          let angle = ((northdif *-1) + photo.exifgpsdirection)
          if(angle > 360) {
            angle = angle - 360
          }

          let target_x = radius * Math.sin(angle * (Math.PI / 180))
          let target_y = radius * Math.cos(angle * (Math.PI / 180))

          let target_x_base = JSON.parse(JSON.stringify(target_x));
          let target_y_base = JSON.parse(JSON.stringify(target_y));

          let anglecalc = '';
          if(angle > 0 && angle < 90) {
            if(target_y > 0) target_y *= -1
            if(target_x < 0) target_x *= -1
            anglecalc = 'A ' + target_x_base + ' ' + target_y_base
          } else if(angle > 90 && angle < 180) {
            if(target_y < 0) target_y *= -1
            if(target_x < 0) target_x *= -1
            anglecalc = 'B ' + target_x_base + ' ' + target_y_base
          } else if(angle > 180 && angle < 270) {
            if(target_y < 0) target_y *= -1
            if(target_x > 0) target_x *= -1
            anglecalc = 'C ' + target_x_base + ' ' + target_y_base
          } else {
            if(target_y > 0) target_y *= -1
            if(target_x > 0) target_x *= -1
            anglecalc = 'D ' + target_x_base + ' ' + target_y_base
          }

          viewx = target_x
          viewy = target_y
        }

        if (photo.x < -2500 || photo.x > 2500 || photo.y < -2500 || photo.y > 2500) {
          console.log('Not added because to big!', photo)
          return
        }

        let runfull = true
        let data = {
          'methodName': 'setFlag',
          'parameters': [{
            'created': moment().format('YYYY-MM-DD HH:mm:ss'),
            'createdDateTime': 0,
            'degree': 180,
            'pdflagid': 0,
            'pdphotoid': photo.pdphotoid,
            'pdplanid': _this.selectedPlan.pdplanid,
            'pdpositionid': 0,
            'pdpositionname': '',
            'photoVO': photo,
            'tiltangle': 0,
            'viewx': viewx,
            'viewy': viewy,
            'xcoord': photo.x,
            'ycoord': photo.y,
            '_explicitType': 'com\projectdocu\FlagVO'
          }],
          serviceName: 'ProjectdocuService'
        }

        if (photo.x >= 2500 || photo.x <= -2500 || photo.y >= 2500 || photo.y <= -2500) {
          _this.$confirm({
            title: 'Flag liegt ausserhalb des Plans!',
            message: 'Soll der Flag trotzdem hinzugefügt werden?',
            button: {
              no: 'Ok'
            },
            callback: confirm => {
              console.log('Confirm', confirm)
            }
          })
        } else {
          console.log('add default Flag')
          _this.createOrUpdateFlags(data, true).then((res) => {
            _this.refreshFlags()
          })
        }

        // if(photo.x >= 5000 || photo.x < 0 || photo.y >= 5000 || photo.y < 0) {
        //   _this.$toast.error('Flag liegt ausserhalb des Plans!')
        // } else {
        //   // console.log('DRAW POINTERS SettedObjectForPointer', obj)
        //   _this.setPointsZoom(_this.zoomRange, obj)
        //   if(_this.canvas != null) {
        //     _this.canvas.add(obj)
        //     this.addArrowPreviewByGps(obj, photo, true, true)
        //   }
        // }

        // _this.canvas.renderAll()
      }
    },

    addPointerPreviewByGps (photo) {
      let _this = this

      let photos = this.getMapLocation(this.selectedPlan.refpoints, [photo])

      console.log('AddPointerByGPS (Photocanvas)', photo, this.selectedPlan, photos)

      for (let i in photos) {
        let photo = photos[i]

        let item = {
          activeflag: true,
          flagcolor: 'blue',
          preview: true
        }

        let obj = _this.createCircleWithText(item)

        let map_coords = this.calculatePositionOnCanvas(photo.x, photo.y)

        obj.set({
          id: 0,
          data: '',
          items: '',
          left: map_coords.x,
          top: map_coords.y,
          originX: 'center',
          originY: 'center',
          selectable: true,
          hasControls: false,
          hasBorders: true,
          preview: true
        })

        console.log('AddArrowPreviewByGps Params BEFORE', {
          'mapCoords_x': map_coords.x,
          'mapCoords_y': map_coords.y,
          'refPoints': this.selectedPlan.refpoints
        })

        if (map_coords.x >= 5000 || map_coords.x < 0 || map_coords.y >= 5000 || map_coords.y < 0) {
          _this.$toast.error('Flag liegt ausserhalb des Plans!')

        } else {
          // console.log('DRAW POINTERS SettedObjectForPointer', obj)
          _this.setPointsZoom(_this.zoomRange, obj)
          if (_this.canvas != null) {
            _this.canvas.add(obj)
            this.addArrowPreviewByGps(obj, photo, true, true)
          }
        }
      }
    },

    addArrowPreviewByGps (obj, img, isCircle = false, newelement = false) {
      let _this = this
      let currentplan = this.selectedPlan
      img.exifgpsdirection = parseFloat(img.exifgpsdirection)

      let northdif = this.getNorthDifference(this.selectedPlan.refpoints)
      let radius = 200 // Distance from point
      let angle = ((northdif *-1) + parseFloat(img.exifgpsdirection))
      if(angle > 360) {
        angle = angle - 360
      }


        //* -1
      // let target_x = radius * Math.sin(Math.PI * 2 * angle / 360)
      // let target_y = radius * Math.cos(Math.PI * 2 * angle / 360)
      // Grad to RAD = GRAD*(PI() / 180)
      let target_x = radius * Math.sin(angle * (Math.PI / 180)) // =SIN(RAD)*RADIUS
      let target_y = radius * Math.cos(angle * (Math.PI / 180)) // =COS(RAD)*RADIUS

      let target_x_base = JSON.parse(JSON.stringify(target_x));
      let target_y_base = JSON.parse(JSON.stringify(target_y));

      let anglecalc = '';
      if(angle > 0 && angle < 90) {
        if(target_y > 0) target_y *= -1
        if(target_x < 0) target_x *= -1
        anglecalc = 'A ' + target_x_base + ' ' + target_y_base
      } else if(angle > 90 && angle < 180) {
        if(target_y < 0) target_y *= -1
        if(target_x < 0) target_x *= -1
        anglecalc = 'B ' + target_x_base + ' ' + target_y_base
      } else if(angle > 180 && angle < 270) {
        if(target_y < 0) target_y *= -1
        if(target_x > 0) target_x *= -1
        anglecalc = 'C ' + target_x_base + ' ' + target_y_base
      } else {
        if(target_y > 0) target_y *= -1
        if(target_x > 0) target_x *= -1
        anglecalc = 'D ' + target_x_base + ' ' + target_y_base
      }



      let c = _this.canvas
      let circle = ''
      c.remove(...c.getObjects().filter((item) => item.get('type') === 'triangle' || item.get('type') === 'line'))

      console.log('AddArrowPreviewByGps Params', {
        'currentplan': currentplan,
        'northdif': northdif,
        'exifgpsdirection': parseFloat(img.exifgpsdirection),
        'angle': angle,
        'target_x': target_x,
        'target_y': target_y,
        'img': img,
        'anglecalc': anglecalc
      })
      if (newelement) {
        circle = isCircle ? obj : obj.getObjects('circle')[0]
      } else {
        circle = !isCircle ? obj : obj.getObjects('circle')[0]
      }


      console.log('AddArrowPreviewByGps', obj, img, circle)
      img = isCircle ? img : obj.data
      let s_x = img.x + target_x
      let s_y = img.y + target_y

      let flagpos = _this.calculatePositionOnCanvas(s_x, s_y)
      let viewXA = flagpos.x
      let viewYA = flagpos.y


      console.log('AddArrowPreviewByGps Res A:', {
        's_x,': s_x,
        's_y,': s_y,
        'this.selectedPlan.refpoints': this.selectedPlan.refpoints,
        'img.xcoord,': img.xcoord,
        'img.ycoord,': img.ycoord,
        'img.viewx,': img.viewx,
        'img.viewy,': img.viewy,
        'img.x,': img.x,
        'img.y,': img.y,
        'viewXA,': viewXA,
        'viewYA,': viewYA,
        'flagpos,': flagpos,
        'northdif,': northdif,
        'img.exifhasgpsdirection,': img.exifhasgpsdirection,
        'img.exifgpsdirection,': img.exifgpsdirection,
        'angle,': angle,
        'target_x,': target_x,
        'target_y,': target_y
      }
      )

      const triangle = new fabric.Triangle({
        // fill: 'red',
        fill: 'blue',
        height: circle.radius * 2.5,
        width: circle.radius * 2,
        top: viewYA,
        left: viewXA,
        hasBorders: false,
        hasControls: false,
        originX: 'center',
        originY: 'center',
        lockScalingX: true,
        lockScalingY: true,
        lockRotation: true,
        preview: true
      })

      const coords = [
        triangle.left,
        triangle.top,
        obj.left + (circle.radius / 10),
        obj.top + (circle.radius / 10)
      ]

      const line = new fabric.Line(coords, {
        // stroke: 'red',
        stroke: 'red',
        strokeWidth: circle.radius,
        selectable: false,
        originX: 'center',
        originY: 'center',
        preview: true
      })

      console.log('Results:', triangle, coords, line)

      function syncObjects (e) {
        const x1 = triangle.left
        const y1 = triangle.top
        const x2 = obj.left + (circle.radius / 10)
        const y2 = obj.top + (circle.radius / 10)

        line.set('x1', x1)
        line.set('y1', y1)
        line.set('x2', x2)
        line.set('y2', y2)

        const angle = _this.calcArrowAngle(x1, y1, x2, y2)

        triangle.set('angle', angle)
        triangle.setCoords()
        c.renderAll()
      }

      syncObjects()

      c.preserveObjectStacking = true
      c.add(line, triangle)
      c.renderAll()
    },

    getNorthDifference (refPoints) {
      if (!refPoints) {
        return 0
      }
      if (refPoints && refPoints.length < 2) {
        return 0
      }
      var refPointP1 = refPoints[0]
      var refPointP2 = refPoints[1]

      var distanceMap = Math.sqrt(
        Math.pow(refPointP2.x - refPointP1.x, 2) +
        Math.pow(refPointP1.y - refPointP2.y, 2))

      var distanceGeo = Math.sqrt(
        Math.pow((refPointP2.lat - refPointP1.lat) * 111, 2) +
        Math.pow((refPointP2.lon - refPointP1.lon) * 111 * Math.cos(Math.PI * (refPointP1.lat + refPointP2.lat) / 360), 2))

      var distanceMultiply = distanceMap / distanceGeo

      var angleMap = this.getAngle((refPointP2.x - refPointP1.x), (refPointP1.y - refPointP2.y))

      var angleGeo = this.getAngle(((refPointP2.lon - refPointP1.lon) * Math.cos(Math.PI * (refPointP1.lat + refPointP2.lat) / 360)), (refPointP2.lat - refPointP1.lat))

      var angleDifference = angleMap - angleGeo


      var grad = (angleDifference * (180 / Math.PI))
      console.log('Grad', grad)

      return grad;

      // let angleres = -180
      let angleres = 0
      //let angleres = grad - 180
      if(grad < 0) {
        angleres = 360 + grad
      } else {
        angleres = angleres + grad
      }

      console.log('AddArrowPreviewByGps AngleDif', {
        'angleMap': angleMap,
        'angleGeo': angleGeo,
        'angleDif': angleDifference,
        'grad': grad,
        'angleRes': angleres
      });
      return angleres
    },

    getMapLocation (refpoints, photos) {
      let _this = this
      let refPointP1 = refpoints[0]
      refPointP1.lat = parseFloat(refPointP1.lat)
      refPointP1.lon = parseFloat(refPointP1.lon)

      let refPointP2 = refpoints[1]
      refPointP2.lat = parseFloat(refPointP2.lat)
      refPointP2.lon = parseFloat(refPointP2.lon)

      if (refPointP1 && refPointP2) {
        let distanceMap = Math.sqrt(
          Math.pow(refPointP2.x - refPointP1.x, 2) +
          Math.pow(refPointP1.y - refPointP2.y, 2)
        )

        let distanceGeo = Math.sqrt(
          Math.pow((refPointP2.lat - refPointP1.lat) * 111, 2) +
          Math.pow((refPointP2.lon - refPointP1.lon) * 111 * Math.cos(Math.PI * (refPointP1.lat + refPointP2.lat) / 360), 2)
        )

        let distanceMultiply = distanceMap / distanceGeo

        var angleMap = _this.getAngle((refPointP2.x - refPointP1.x), (refPointP1.y - refPointP2.y))

        var angleGeo = _this.getAngle(((refPointP2.lon - refPointP1.lon) *
          Math.cos(Math.PI * (refPointP1.lat + refPointP2.lat) / 360)),
          (refPointP2.lat - refPointP1.lat))

        var angleDifference = angleMap - angleGeo

        // for(var i = 0; i < photos.length; i++) {

        for (let i in photos) {
          let photoVO = photos[i]

          if (photoVO.exifhasgps) {
            photoVO.lat = parseFloat(photoVO.exifgpsy)
            photoVO.lon = parseFloat(photoVO.exifgpsx)

            distanceGeo = Math.sqrt(
              Math.pow((refPointP1.lat - photoVO.lat) * 111, 2) +
              Math.pow((refPointP1.lon - photoVO.lon) * 111 * Math.cos(Math.PI * (refPointP1.lat + photoVO.lat) / 360), 2))

            console.log('inPhotos - angleGeo', photoVO.lon, refPointP1.lon, Math.PI, refPointP1.lat, photoVO.lat, refPointP1.lat)

            angleGeo = _this.getAngle(((photoVO.lon - refPointP1.lon) *
              Math.cos(Math.PI * (refPointP1.lat + photoVO.lat) / 360)),
              (photoVO.lat - refPointP1.lat))

            var angle = (angleGeo + angleDifference) % (2 * Math.PI)

            console.log('inPhotos-X', refPointP1.x, distanceGeo, distanceMultiply, angleGeo, angle, Math.cos(angle))
            console.log('inPhotos-Y', refPointP1.y, distanceGeo, distanceMultiply, angleGeo, angle, Math.sin(angle))

            photoVO.x = refPointP1.x + distanceGeo * distanceMultiply * Math.cos(angle)
            photoVO.y = refPointP1.y - distanceGeo * distanceMultiply * Math.sin(angle)
          }
        }
      }

      return photos
    },

    getAngle (dx, dy) {
      if (dx > 0) {
        return Math.atan(dy / dx)
      } else if (dx < 0 && dy >= 0) {
        return Math.atan(dy / dx) + Math.PI
      } else if (dx < 0 && dy < 0) {
        return Math.atan(dy / dx) - Math.PI
      } else if (dx === 0 && dy > 0) {
        return Math.PI
      } else if (dx === 0 && dy < 0) {
        return -1 * Math.PI
      } else if (dx === 0 && dy === 0) {
        return 0
      }

      return Math.atan2(dy, dx)
    },

    setFlagsByImageGps () {
      let _this = this

      if (_this.editrangeselect != 'all') {
        _this.$toast.error('Zeitraum muss auf Alle gestellt sein')
        return
      }

      let gpsfotos = this.photos.filter((photo) => photo.exifhasgps == 1)

      let existingflags = this.all_flags

      gpsfotos.forEach(function (val, idx) {
        let existing = _this.all_flags.filter((existingflag) => val.pdphotoid == existingflag.pdphotoid)
        if (existing.length <= 0) {
          _this.addPointerByGps(val)
        }
      })

      return true
      // console.log('this.imgSrc', this)
      // return obj.imgSrc
    }

  }
}

</script>
<style scoped>
  .active{
    background-color: #39F !important;
    color: #ffffff !important;
  }
  .table td{
    padding: 0.5rem 0 !important;
  }
  .search-box{
    z-index: 99;
  }
.visible {
  visibility: visible !important;
}

.zoom:hover {
  border: 1px solid darkgray !important;
}

.img-loading {
  max-height: 100%;
  margin-top: 5rem;
  z-index: 1000;
}

#canvas_div {
  min-height: 88%;
}

i.icon-cancel {
  right: 7px;
  cursor: pointer;
  top: 7px;
  background: black;
  border-radius: 50%;
  font-size: 1.1rem;
  z-index: 1000;
}

i.icon-cancel:hover {
  font-size: 1.3rem !important;
  z-index: 10000;
}

#single_temp_popup {
  visibility: hidden;
  z-index: 100;
}

.zoom-loading {
  z-index: 1000;
  background: lightgray;
  height: 100%;
}

.img-border {
  border: 1px solid blue !important;
}

.close-preview {
  z-index: 1000;
  font-size: 1.2rem;
  top: -13px;
  right: -20px;
  cursor: pointer;
}

.close-preview .fa {
  background: #ffffff69;
  border-radius: 5px;
}

.flag-delete {
  font-size: 1rem;
  background: #ffffff69;
  left: 49px;
  z-index: 1000;
  cursor: pointer;
}

.zoomImgFrame {
  /*padding: 10px;*/
  padding: 0px;
  border-radius: 10px;
  border: 2px solid #39F;
  z-index: 100;
  left: -65%;
  /*top:20px;*/
  width:65%;
  max-height: 80%;
  height: auto;
  background-color: white;
  overflow: hidden;
}
.zoomImgFrame img {
  width:100%;
  height: 100%;
  z-index: 100;
  margin:0px auto;

  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/photo/components/PhotosCanvas.vue